<!-- <mat-spinner  *ngIf="isLoading" class="loader" >

   <img src="./assets/images/runloyal_loading.gif" width="64" height="64"  />

</mat-spinner> -->

<!-- <div class="text-right">
   <button mat-icon-button color="primary" id="web_appo_close" (click)="onclickClose($event)">
      <mat-icon>close</mat-icon>
   </button>
</div> -->
<div class="card appo-card">
   <div class="card-header text-center">
      <img alt="Pawops" height="100px" class="logo" src={{tenantLogo}} style="padding:10px;border-radius:10px;">
   </div>
   <div class="card" id="banner-content" *ngIf="versionDetail && versionDetail.showBanner == 'true'"
      class="alert-banner-content" [ngStyle]="{'background-color':versionDetail.showBannerColor}">
      <div class="card-header text-center">
         <h1 class="card-title">{{versionDetail.showBannerTitle || ''}}</h1>
         <button mat-icon-button class="primary alert-banner-close" id="web_appo_close" (click)="hideBannerContent()"
            *ngIf="versionDetail.showBannerClose=='true'">
            <mat-icon>close</mat-icon>
         </button>
      </div>
      <div class="card-body text-center">
         <div class="" id="banner_els" [ngClass]="{ 'banner_els': !showBannerFullContent }">
            <p class="alert-banner-content" [innerHTML]="sanitizedBannerContent"></p>
         </div>
         <span (click)="showBannerContent()" class="margin-10 cursor-pointer">{{showBannerFullContent ? 'Read less' :
            'Read more'}}</span>
      </div>
   </div>
   <div class="card-body">
      <ng-template #serviceMapModal>
         <div class="modal-body text-center p-5">
            <h4>Do you want to select same service for pet #{{currentPetNo + 1}}?</h4>
            <button type="button" class="btn btn-default mr-5" (click)="decline()">No</button>
            <button type="button" class="btn btn-primary" (click)="confirm()">Yes</button>
         </div>
      </ng-template>
      <div id="serviceType" style="text-align:center;margin-top:10px;font-size: 18px;"
         *ngIf="stepper.selectedIndex === 0 && (allowPackagePurchase || allowMembershipPurchase || allowTrainingPurchase)">
         <mat-radio-group name="purchaseType" [(ngModel)]="selectedPurchaseType"
            (change)="onPurchaseTypeChange($event)">
            <mat-radio-button value="service" *ngIf="allowBookingServices"><img src="assets/images/service-icon.png"
                  style="height: 20px;vertical-align: bottom;"> Book Services</mat-radio-button>
            <mat-radio-button value="membership" *ngIf="allowMembershipPurchase"><img src="assets/images/crown.svg"
                  style="height: 20px;width: 20px;vertical-align: bottom;"> Memberships</mat-radio-button>
            <mat-radio-button value="package" *ngIf="allowPackagePurchase"><img src="assets/images/packagegreen.svg"
                  style="height: 20px;width: 20px;"> Packages</mat-radio-button>
            <mat-radio-button value="training" *ngIf="allowTrainingPurchase"><img
                  src="assets/images/group-traininigs.png" style="height: 20px;width: 20px;">Training
               Services</mat-radio-button>
         </mat-radio-group>
      </div>
      <mat-horizontal-stepper [linear]="true" #stepper>
         <mat-step>
            <!-- <button mat-button matStepperNext>Next</button> -->
            <form *ngIf="selectedPurchaseType == 'service'">
               <ng-template matStepLabel>Appointment</ng-template>
               <div class="form-group" *ngIf="app_android || app_ios">
                  <label class="card-title font-weight-bold mb-0 headeer">Make this appointment using our app!</label>
                  <div class="card-text">Download today to make appointment, manage your profile, and much more!
                  </div>
                  <div class="mb-2 mt-4">
                     <a [href]="app_ios" target="_blank" *ngIf="app_ios">
                        <img src="assets/images/appStoreImg.png" alt="Pawops" height="40">
                     </a>
                     <a [href]="app_android" target="_blank" *ngIf="app_android">
                        <img src="assets/images/googlePlayImg.png" alt="Pawops" height="40">
                     </a>
                  </div>
               </div>

               <ng-container *ngIf="multiLocation.length > 1">

                  <label for="location" class="font-weight-bold headeer">Which location?</label>

                  <div class="form-group mb-0">

                     <mat-form-field appearance="outline">
                        <mat-label>Location</mat-label>
                        <mat-select [formControl]="locationCtrl" (selectionChange)="onLocationChangeNew($event)">
                           <mat-option *ngFor="let location of multiLocation" [value]="location?.locationKey">
                              {{location?.locationName}}
                           </mat-option>
                        </mat-select>

                        <mat-error *ngIf="locationCtrl.invalid">{{ getErrorMessage(locationCtrl, 'Location', 'required')
                           }}</mat-error>
                     </mat-form-field>
                  </div>

               </ng-container>

               <!-- Locations -->

               <div class="form-group">
                  <label for="petType" class="font-weight-bold headeer">Pet type?</label>

                  <div id="petType" style="margin-top: 10px;">
                     <mat-button-toggle-group name="petType" aria-label="Pet Types" [(ngModel)]="selectedPetID"
                        [ngModelOptions]="{standalone: true}" (change)="onPetTypeChange($event)" required>
                        <mat-button-toggle *ngFor="let petType of petTypes | filter: filterValidPetTypeForService" [value]="petType.id">
                           {{petType.name}}</mat-button-toggle>
                     </mat-button-toggle-group>

                     <!-- <mat-chip-list aria-label="Fish selection" name="petType" aria-label="Pet Types" [(ngModel)]="selectedPetID"
                     [ngModelOptions]="{standalone: true}" (change)="onPetTypeChange($event)" required>
                        <mat-chip color="primary"  class="btn-custom mr-23" *ngFor="let petType of petTypes" [value]="petType.id">  {{petType.name}}</mat-chip>
                      </mat-chip-list> -->


                  </div>
               </div>
               <div class="form-group">
                  <label for="petNum" class="font-weight-bold">How many pets?</label>
                  <div id="petNum">
                     <mat-button-toggle-group name="petNum" aria-label="Pet Number" [(ngModel)]="selectedPetNum"
                        [ngModelOptions]="{standalone: true}" (change)="onPetNumChange($event)" required>
                        <mat-button-toggle value="1">1</mat-button-toggle>
                        <mat-button-toggle value="2">2</mat-button-toggle>
                        <mat-button-toggle value="3">3</mat-button-toggle>
                        <mat-button-toggle value="4">4</mat-button-toggle>
                     </mat-button-toggle-group>
                  </div>
               </div>
               <div class="form-group" *ngIf="hasFirstPetServices">
                  <label for="poType" class="font-weight-bold headeer">About you</label>
                  <div id="poType">
                     <mat-radio-group name="poType" [(ngModel)]="petOwnerType" (change)="onnPOTypeChange($event)">
                        <mat-radio-button value="firstTimeAppointment">This is my first appointment or first
                           pet</mat-radio-button>
                        <mat-radio-button value="allReadyBookedAppointment">I have already booked appointment with
                           them</mat-radio-button>
                     </mat-radio-group>
                  </div>
               </div>
               <div class="form-group"
                  *ngIf="hasBundledAssociatedServices && (!hasFirstPetServices || (petOwnerType && petOwnerType == 'allReadyBookedAppointment'))">
                  <label for="appointmentType" class="font-weight-bold headeer">Appointment type</label>
                  <div id="appointmentType">
                     <mat-radio-group name="appointmentType" [(ngModel)]="appointmentType"
                        (change)="onAppointmentTypeChange($event)">
                        <mat-radio-button value="REGULAR" *ngIf="this.reservationTypes && this.reservationTypes.length > 0">Individual Services </mat-radio-button>
                        <mat-radio-button value="ASSOCIATED"
                           *ngIf="associatedReservationTypes && associatedReservationTypes.length > 0"> Bundled
                           Services</mat-radio-button>
                        <mat-radio-button value="BUNDLED"
                           *ngIf="bundledReservationTypes && bundledReservationTypes.length > 0"> Bundled Experiences
                        </mat-radio-button>
                     </mat-radio-group>
                  </div>
               </div>
               <!-- <mat-tab-group> -->
               <!-- <mat-tab class="btn-custom" label="Pet 1"> -->
               <div class="form-group" *ngIf="this.reservationTypes.length>0 && appointmentType == 'REGULAR'">
                  <label for="serviceType" class="font-weight-bold headeer">Which type of services?</label>
                  <div id="serviceType">

                     <mat-accordion>
                        <ng-container *ngFor="let reservationType of reservationTypes">
                           <mat-expansion-panel [expanded]="openAccordion"
                              (opened)="selectCategory(reservationType.id,false)" #panel
                              *ngIf="(reservationType.services | filter: filterNoAddOnHasPriceTiers).length > 0">
                              <mat-expansion-panel-header>
                                 <mat-panel-title style="align-items:center;">
                                    <div class="service-icon"
                                       [ngClass]="{'hightlight-iconurl' : (reservationType.document && reservationType.document.id)}"
                                       (click)="$event.preventDefault();showImages(reservationType)"><img
                                          src={{reservationType.iconUrl}} /> </div>
                                    <span class="service-type">{{reservationType.name}}
                                       <img *ngIf="checkDescription(reservationType)" src="assets/images/info-a-35.png"
                                          alt="info_image" height="15" style="border-radius: 50%;"
                                          [matTooltip]="toolTipText" matTooltipClass="web-appntment-toolTip"
                                          (mouseenter)="getDescription(reservationType)" />
                                    </span>
                                 </mat-panel-title>
                              </mat-expansion-panel-header>
                              <mat-selection-list #serviceSelections [multiple]="true"
                                 (selectionChange)="onServiceChange($event, reservationType,null)">
                                 <ng-container
                                    *ngFor="let service of reservationType.services | filter: filterNoAddOnHasPriceTiers">
                                    <ng-container *ngIf="!service.hideFromDevices">
                                       <mat-list-option [selected]="service.selected" [value]="service.id" class="min-height-48">
                                          <span class="d-flex justify-space-between gap-5">
                                             <span class="reservation-service-name">
                                                {{service.name}}
                                                <img *ngIf="checkDescription(service)" src="assets/images/info-a-35.png"
                                                   alt="info_image" height="15" style="border-radius: 50%;"
                                                   [matTooltip]="toolTipText" matTooltipClass="web-appntment-toolTip"
                                                   (mouseenter)="getDescription(service)" />
                                             </span>
                                             <span class="reservation-service-pricing"
                                                *ngIf="reservationType.showPricing && service.showPricing != false && service.price">{{service.price}}</span>
                                          </span>
                                       </mat-list-option>
                                    </ng-container>
                                 </ng-container>
                              </mat-selection-list>
                           </mat-expansion-panel>
                        </ng-container>
                     </mat-accordion>


                     <mat-error *ngIf="!selectedServiceID" class="mt-1 ml-2"> Service type is
                        <strong>required</strong>
                     </mat-error>
                  </div>
               </div>
               <div class="form-group"
                  *ngIf="(appointmentType == 'ASSOCIATED' && associatedReservationTypes.length > 0)  || (appointmentType == 'BUNDLED' && bundledReservationTypes.length > 0)">
                  <label for="serviceType" class="font-weight-bold headeer">Which type of services?</label>
                  <div id="serviceType">
                     <mat-accordion *ngIf="appointmentType == 'BUNDLED' && this.bundledReservationTypes.length > 0">
                        <ng-container *ngFor="let reservationType of bundledReservationTypes">
                           <mat-expansion-panel #panelBundled>
                              <mat-expansion-panel-header  class="min-height-48"
                                 (click)="onBundleAssociatedServiceChange(reservationType, 'BUNDLED')">
                                 <mat-panel-title class="justify-space-between item-center">
                                    <span class="service-type">{{reservationType.name}}
                                       <img *ngIf="checkDescription(reservationType)" src="assets/images/info-a-35.png"
                                          alt="info_image" height="15" style="border-radius: 50%;"
                                          [matTooltip]="toolTipText" matTooltipClass="web-appntment-toolTip"
                                          (mouseenter)="getDescription(reservationType)" />
                                    </span>
                                    <mat-radio-button
                                       (change)="onBundleAssociatedServiceChange(reservationType, 'BUNDLED')"
                                       [checked]="selectedBundledAssociatedService && selectedBundledAssociatedService.id == reservationType.id"
                                       style="flex: 0;"></mat-radio-button>
                                 </mat-panel-title>
                              </mat-expansion-panel-header>
                              <div class="membership-accordion bundle-experience-details">
                                 <div class="bundled-experience-description">
                                    {{ reservationType.description }}
                                 </div>

                                 <div class="bundled-experience-pricing-info">
                                    <span *ngIf="reservationType.showPricing"> {{ reservationType.price }} </span>
                                    Includes:
                                 </div>

                                 <ol class="bundled-experience-reservation-list">
                                    <li *ngFor="let reservationDetail of reservationType.reservationTypes"
                                       class="bundled-experience-reservation-item">
                                       <div class="bundled-experience-reservation-name"
                                          *ngIf="reservationDetail && reservationDetail.services && reservationDetail.services.length > 0">
                                          {{ reservationDetail.name }}
                                       </div>

                                       <ul class="bundled-experience-service-list">
                                          <li *ngFor="let service of reservationDetail.services"
                                             class="bundled-experience-service-item">
                                             <div class="bundled-experience-service-name">{{ service.name }}</div>

                                             <ul *ngIf="service.mandatoryServices && service.mandatoryServices.length"
                                                class="bundled-experience-mandatory-service-list">
                                                <li *ngFor="let mandatoryService of service.mandatoryServices"
                                                   class="bundled-experience-mandatory-service-name">
                                                   {{ mandatoryService.name }}
                                                </li>
                                             </ul>
                                          </li>
                                       </ul>
                                    </li>
                                 </ol>
                              </div>

                           </mat-expansion-panel>
                        </ng-container>
                     </mat-accordion>
                     <mat-accordion
                        *ngIf="appointmentType == 'ASSOCIATED' && this.associatedReservationTypes.length > 0">
                        <ng-container *ngFor="let reservationType of associatedReservationTypes">
                           <mat-expansion-panel #panelAssociated class="membership-dropdown-none">
                              <mat-expansion-panel-header  class="min-height-48"
                                 (click)="onBundleAssociatedServiceChange(reservationType, 'ASSOCIATED')">
                                 <mat-panel-title style="align-items:center;justify-content: space-between">
                                    <span class="service-type">{{reservationType.name}}
                                       <img *ngIf="checkDescription(reservationType)" src="assets/images/info-a-35.png"
                                          alt="info_image" height="15" style="border-radius: 50%;"
                                          [matTooltip]="toolTipText" matTooltipClass="web-appntment-toolTip"
                                          (mouseenter)="getDescription(reservationType)" />
                                    </span>
                                    <mat-radio-button
                                       (change)="onBundleAssociatedServiceChange(reservationType, 'ASSOCIATED')"
                                       [checked]="selectedBundledAssociatedService && selectedBundledAssociatedService.id == reservationType.id"
                                       style="flex: 0;"></mat-radio-button>
                                 </mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-container>
                              </ng-container>
                           </mat-expansion-panel>
                        </ng-container>
                     </mat-accordion>
                  </div>
               </div>
               <!-- <mat-tab label="Grooming : Mini Groom"> -->
               <label *ngIf="selectedServiceMap && selectedServiceMap.length > 0" for="serviceType"
                  class="font-weight-bold headeer">Selected Services</label>
               <mat-accordion>
                  <ng-container *ngFor="let reservation of selectedServiceMap | keyvalue: keepInsertionOrder">
                     <ng-container *ngIf="reservation.value.service">
                        <mat-expansion-panel #expansionPanels [attr.data-key]="reservation.key"
                           (opened)="selectCategory(reservation.key,false)" class="selected-service-accordion">
                           <mat-expansion-panel-header style="height:48px !important;">
                              <mat-panel-title class="item-center color-white">
                                 <span class="service-type">{{reservation.value.service.name}}
                                 </span>
                              </mat-panel-title>
                           </mat-expansion-panel-header>
                           <div class="margin-t15" *ngIf="reservation.key == selectedReservationTypeID">
                              <div class="form-group" *ngIf="datePickerType">
                                 <label for="datePicker" class="font-weight-bold headeer">When would you like this
                                    service?</label>

                                 <div
                                    style="display: flex;flex-direction: row;align-items: center;margin-bottom: 15px;">
                                    <div
                                       style="display: flex;flex-direction: row;align-items: center;margin-right: 10px;">
                                       <div
                                          style="height: 15px;width: 15px;background-color: #C6382B;border-radius: 50%;">
                                       </div>
                                       &nbsp;Not Available
                                    </div>
                                    <div style="display: flex;flex-direction: row;align-items: center;">
                                       <div
                                          style="height: 15px;width: 15px;background-color: #FFA500;border-radius: 50%;">
                                       </div>
                                       &nbsp;Peak Days
                                    </div>
                                 </div>
                                 <mat-error
                                    *ngIf="selectedServiceMap[selectedReservationTypeID] && selectedServiceMap[selectedReservationTypeID]['startDate'] ? '':'' ||selectedServiceMap[selectedReservationTypeID] && selectedServiceMap[selectedReservationTypeID]['endDate'] ? '':'true'"
                                    class="mt-1 ml-2" style="text-align: center;background-color: #6633990d;
                                                                           border-radius: 3px;">Start Date And End Date
                                    Are
                                    <strong>Required!</strong></mat-error>
                                 <div id="datePicker">
                                    <div class="pb-3" *ngIf="datePickerType == 'Single'">
                                       <h5 style="font-size: 18px;">Select Date</h5>
                                       <mat-calendar #calendar style="width: 50%;" [minDate]="minDate"
                                          [selected]="startDateObject" (monthSelected)="onMonthChange($event)"
                                          (selectedChange)="onSingleDateChange($event)" [dateClass]="dateClass()"
                                          [dateFilter]="minWindowFilter" [maxDate]="maxDate">
                                       </mat-calendar>
                                       <mat-error
                                          *ngIf="selectedServiceMap[selectedReservationTypeID] && selectedServiceMap[selectedReservationTypeID]['startDate'] ? '':'true'"
                                          class="mt-1 ml-2"> Date is <strong>required</strong></mat-error>
                                    </div>
                                    <div class="pb-3" *ngIf="datePickerType == 'Range'">
                                       <div style="display: flex;justify-content: space-around;">
                                          <h5 style="font-size: 18px;">Select Start / Drop Off Date</h5>
                                          <h5 style="font-size: 18px;">Select End / Pick Up Date</h5>
                                       </div>
                                       <div style="display: flex;margin-top: -35px;">
                                          <mat-calendar #calendar1 style="width: 50%;" class="range-start"
                                             [minDate]="minDate" [maxDate]="maxDate" [selected]="startDateObject"
                                             (monthSelected)="onMonthChange($event)"
                                             (selectedChange)="onStartDateChange($event)" [dateClass]="dateClass()"
                                             [dateFilter]="minWindowFilter">
                                          </mat-calendar>
                                          <mat-calendar #calendar2 style="width: 50%;" class="range-end"
                                             [minDate]="minEndDate" [maxDate]="maxDate" [selected]="endDateObject"
                                             (monthSelected)="onMonthChange($event)"
                                             (selectedChange)="onEndDateChange($event)" [dateClass]="dateClass()"
                                             [dateFilter]="minWindowFilter">
                                          </mat-calendar>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div class="form-group"
                                 *ngIf="datePickerType == 'Single'  && selectedServiceMap[this.selectedReservationTypeID] && !selectedServiceMap[this.selectedReservationTypeID].showStaff && selectedServiceMap[this.selectedReservationTypeID].scheduleType != 'STAFF_BASED'">

                                 <label for="slotPicker" class="font-weight-bold headeer">Select Drop Off time</label>
                                 <div id="slotPicker">
                                    <mat-radio-group aria-labelledby="example-radio-group-label"
                                       class="example-radio-group chip-form" [ngModelOptions]="{standalone: true}"
                                       (change)="timeSlotChanged($event)">

                                       <mat-radio-button class="example-radio-button" *ngFor="let timeSlot of timeSlots"
                                          [checked]="checkEqualSlot('timeSlot', 'name', timeSlot)" [value]="timeSlot">
                                          {{reservationTypesMap[selectedReservationTypeID].autoApproval ? timeSlot.lable
                                          :
                                          timeSlot.lable}}
                                       </mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error *ngIf="showTimeSlotNotAvailable && timeSlots.length==0"
                                       class="mt-1 ml-2"> There is no
                                       available
                                       time
                                       slot.
                                    </mat-error>
                                    <mat-error *ngIf="!selectedTime && timeSlots.length>0" class="mt-1 ml-2"> Time Slot
                                       is
                                       <strong>required</strong>
                                    </mat-error>
                                 </div>
                                 <ng-container *ngIf="PickTimeSlots.length > 0">
                                    <label for="slotPicker" class="font-weight-bold headeer">Select Pick up time</label>

                                    <div id="slotPicker">
                                       <mat-radio-group aria-labelledby="example-radio-group-label"
                                          class="example-radio-group chip-form" [ngModelOptions]="{standalone: true}"
                                          (change)="DropTimeSlot($event)">

                                          <mat-radio-button class="example-radio-button"
                                             *ngFor="let timeSlot of PickTimeSlots"
                                             [checked]="checkEqualSlot('timeSlot_end', 'name', timeSlot)"
                                             [value]="timeSlot">
                                             {{reservationTypesMap[selectedReservationTypeID].autoApproval ?
                                             timeSlot.lable :
                                             timeSlot.lable}}
                                          </mat-radio-button>
                                       </mat-radio-group>


                                       <mat-error *ngIf="PickTimeSlots.length==0" class="mt-1 ml-2"> There is no
                                          available time
                                          slot.
                                       </mat-error>
                                       <mat-error *ngIf="!selectedDropTime && PickTimeSlots.length>0" class="mt-1 ml-2">
                                          Time Slot is
                                          <strong>required</strong>
                                       </mat-error>
                                    </div>
                                 </ng-container>
                              </div>

                              <div class="form-group"
                                 *ngIf="datePickerType == 'Single' && selectedServiceMap[this.selectedReservationTypeID] && (selectedServiceMap[this.selectedReservationTypeID].showStaff || selectedServiceMap[this.selectedReservationTypeID].scheduleType == 'STAFF_BASED')">
                                 <label for="staffPicker" class="font-weight-bold headeer"
                                    *ngIf="listOfStaffSlots && listOfStaffSlots.length > 0">Select Staff</label><br>
                                 <div *ngFor="let time of listOfStaffSlots" class="d-flex">
                                    <label class="acc-heading" style="width:20%">
                                       {{time.lable}}
                                    </label>

                                    <mat-radio-group aria-labelledby="example-start-group-label"
                                       class="example-radio-group chip-form" style="width:80%"
                                       *ngIf="selectedServiceMap[this.selectedReservationTypeID].scheduleType!='STAFF_BASED'"
                                       [value]="selectedStaff" [ngModelOptions]="{standalone: true}"
                                       (change)="selectStaff($event, time)">
                                       <mat-radio-button class="example-radio-button"
                                          *ngFor="let name of time.employees" [value]="name"
                                          [checked]="checkEqualStaff(name, time)">
                                          {{name.firstName}} {{name.lastName}}
                                       </mat-radio-button>
                                    </mat-radio-group>
                                    <mat-radio-group aria-labelledby="example-start-group-label"
                                       class="example-radio-group chip-form" style="width:80%"
                                       *ngIf="selectedServiceMap[this.selectedReservationTypeID].scheduleType=='STAFF_BASED'"
                                       [value]="selectedStaff" [ngModelOptions]="{standalone: true}">
                                       <mat-radio-button class="example-radio-button" *ngFor="let name of time.slots"
                                          [value]="name" [checked]="checkEqualStaffSlot(name, time)"
                                          (change)="selectStaffforSlot($event, name, time)">
                                          {{name.lable}}
                                       </mat-radio-button>
                                    </mat-radio-group>
                                 </div>
                                 <mat-error *ngIf="showNoSlotAvailable" class="mt-1 ml-2"> There is no available
                                    time slot.
                                 </mat-error>
                                 <mat-error *ngIf="!selectedStaff && listOfStaffSlots.length>0" class="mt-1 ml-2"> Time
                                    Slot is <strong>required</strong>
                                 </mat-error>
                              </div>
                              <div class="form-group" *ngIf="datePickerType == 'Range'">

                                 <mat-error *ngIf="!selectedStartTime || !selectedEndTime" class="mt-1 ml-2" style="    text-align: center;
                                                                                       margin-bottom: 18px;
                                                                                       background-color: #6633990d;
                                                                              border-radius: 3px;"> Drop Off Time And
                                    Pick Up Time
                                    <strong>Required
                                       !</strong>
                                 </mat-error>

                                 <div class="row" id="slotRangePicker">
                                    <div class="col-6">
                                       <div><label class="font-weight-bold headeer">Select Drop Off Time</label></div>
                                       <mat-radio-group aria-labelledby="example-start-group-label"
                                          class="example-radio-group chip-form" [value]="selectedStartTime"
                                          [ngModelOptions]="{standalone: true}" (change)="startTimeSlotChanged($event)">
                                          <mat-radio-button class="example-radio-button"
                                             *ngFor="let timeSlot of rangeInSlots"
                                             [checked]="checkEqualSlot('startTime', 'name', timeSlot)"
                                             [value]="timeSlot">
                                             {{timeSlot.lable}}
                                          </mat-radio-button>
                                       </mat-radio-group>

                                    </div>
                                    <div class="col-6">
                                       <div><label class="font-weight-bold headeer">Select Pick Up Time</label></div>
                                       <mat-radio-group aria-labelledby="example-end-group-label"
                                          class="example-radio-group chip-form" [value]="selectedEndTime"
                                          [ngModelOptions]="{standalone: true}" (change)="endTimeSlotChanged($event)">
                                          <mat-radio-button class="example-radio-button"
                                             *ngFor="let timeSlot of rangeOutSlots"
                                             [checked]="checkEqualSlot('endTime', 'name', timeSlot)" [value]="timeSlot">
                                             {{timeSlot.lable}}
                                          </mat-radio-button>
                                       </mat-radio-group>
                                    </div>
                                 </div>
                              </div>

                              <div class="form-group" *ngIf="showGroupAddOnServices && isReservationHasGroupAddOn()">
                                 <label for="addOnService" class="font-weight-bold headeer">Group Add-on
                                    Services</label>
                                 <div id="addOnService">
                                    <ul>
                                       <ng-container *ngFor="let service of groupAddOnServices">
                                          <li *ngIf="service.reservationTypeId == selectedReservationTypeID">
                                             <mat-checkbox [(ngModel)]="service.selected"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="onChangeGroupAddOnServices(service)">
                                                {{service.name}}
                                                <img src="assets/images/info-a-35.png" alt="info_image" height="15"
                                                   style="border-radius: 50%;" [matTooltip]="toolTipText"
                                                   matTooltipClass="web-appntment-toolTip"
                                                   (mouseenter)="showAddOnName(service.addOns)" />
                                             </mat-checkbox>
                                          </li>
                                       </ng-container>
                                    </ul>
                                 </div>
                              </div>

                              <div class="form-group"
                                 *ngIf="selectedServiceMap[selectedReservationTypeID].bundledAddOns && selectedServiceMap[selectedReservationTypeID].bundledAddOns.length > 0">
                                 <label for="addOnService" class="font-weight-bold headeer">Bundled Add-ons</label>
                                 <div id="addOnService">
                                    <ul>
                                       <ng-container
                                          *ngFor="let service of selectedServiceMap[selectedReservationTypeID].bundledAddOns">
                                          <li *ngIf="isServiceMapped(service)">
                                             <mat-checkbox [(ngModel)]="service.selected"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="onChangeBudledAddOnServices(service)">
                                                {{service.name}}
                                                <img src="assets/images/info-a-35.png" alt="info_image" height="15"
                                                   style="border-radius: 50%;" [matTooltip]="toolTipText"
                                                   matTooltipClass="web-appntment-toolTip"
                                                   (mouseenter)="showAddOnNameForBundle(service)" />
                                                   &nbsp; <span class="tenant-text-color" *ngIf="selectedServiceMap[selectedReservationTypeID].showPricing && service.showPricing != false && service.price">({{service.price}})</span>
                                             </mat-checkbox>
                                             <section class="add-on-date-selector"
                                                *ngIf="service.selected && datePickerType == 'Range'">
                                                <label class="ml-4">How Often? :</label>
                                                <mat-radio-group [(ngModel)]="service.isEveryDay"
                                                   [ngModelOptions]="{standalone: true}"
                                                   (change)="dayTypeRadioChangedBundled($event, service)">
                                                   <mat-radio-button [value]="false">Specific Day(s)</mat-radio-button>
                                                   <mat-radio-button [value]="true">Every Day</mat-radio-button>
                                                </mat-radio-group>
                                                <section class="ml-5">
                                                   <mat-checkbox class="mr-3" [(ngModel)]="dateStr.checked"
                                                      (change)="addOnServiceDateCheckChangeBundled($event, service,dateStr)"
                                                      [ngModelOptions]="{standalone: true}"
                                                      *ngFor="let dateStr of service.dateList">
                                                      {{dateStr.value}}</mat-checkbox>
                                                </section>
                                             </section>
                                          </li>
                                       </ng-container>
                                    </ul>
                                 </div>
                              </div>

                              <ng-container *ngIf="showPrimaryServicesInView">
                                 <div class="form-group" *ngIf="selectedServiceMap[selectedReservationTypeID]">
                                    <label for="addOnService" class="font-weight-bold headeer">Select Primary
                                       Services</label>
                                    <div id="addOnService">
                                       <ul>
                                          <ng-container
                                             *ngFor="let service of selectedServiceMap[selectedReservationTypeID].addOn">
                                             <ng-container *ngIf="service.parentAddOn == false">
                                                <li
                                                   *ngIf="!service.hideFromDevices || (allowHiddenAddOns && service.serviceGroupID)">
                                                   <mat-checkbox [ngModel]="service.selected"
                                                      [ngModelOptions]="{standalone: true}"
                                                      [disabled]="service.serviceGroupID"
                                                      (ngModelChange)="updateAddOnServiceCheck($event, service)">
                                                      {{service.name}} <img *ngIf="checkDescription(service)"
                                                         src="assets/images/info-a-35.png" alt="info_image" height="15"
                                                         style="border-radius: 50%;" [matTooltip]="toolTipText"
                                                         matTooltipClass="web-appntment-toolTip"
                                                         (mouseenter)="getDescription(service)" />
                                                         &nbsp; <span class="tenant-text-color" *ngIf="selectedServiceMap[selectedReservationTypeID].showPricing && service.showPricing != false && service.price">({{service.price}})</span>
                                                   </mat-checkbox>
                                                   <section class="add-on-date-selector"
                                                      *ngIf="service.selected && datePickerType == 'Range'">
                                                      <label class="ml-4">How Often? :</label>
                                                      <mat-radio-group [(ngModel)]="service.isEveryDay"
                                                         [disabled]="service.serviceGroupID && (!selectedBundledAssociatedService || service.serviceGroupID != selectedBundledAssociatedService.id)"
                                                         [ngModelOptions]="{standalone: true}"
                                                         (change)="dayTypeRadioChanged($event, service)">
                                                         <mat-radio-button [value]="false">Specific
                                                            Day(s)</mat-radio-button>
                                                         <mat-radio-button [value]="true">Every Day</mat-radio-button>
                                                      </mat-radio-group>
                                                      <section class="ml-5">
                                                         <ng-container *ngFor="let dateStr of service.dateList">
                                                            <mat-checkbox class="mr-3" [(ngModel)]="dateStr.checked"
                                                               [disabled]="service.serviceGroupID && (!selectedBundledAssociatedService || service.serviceGroupID != selectedBundledAssociatedService.id)"
                                                               [ngModelOptions]="{standalone: true}"
                                                               (change)="addOnServiceDateCheckChange($event, service)"
                                                               [ngModelOptions]="{standalone: true}"
                                                               *ngIf="dateStr.isAvailable">
                                                               {{dateStr.value}}
                                                            </mat-checkbox>
                                                         </ng-container>
                                                      </section>
                                                   </section>
                                                </li>
                                             </ng-container>
                                          </ng-container>
                                       </ul>
                                    </div>
                                 </div>
                              </ng-container>

                              <div class="form-group"
                                 *ngIf="selectedServiceMap[selectedReservationTypeID] && isReservationHasAddOn()">
                                 <label for="addOnService" class="font-weight-bold headeer">Select add-on
                                    Services</label>
                                 <div id="addOnService">
                                    <ul>
                                       <ng-container
                                          *ngFor="let service of selectedServiceMap[selectedReservationTypeID].addOn">
                                          <ng-container *ngIf="!checkPropertyPresent(service, 'parentAddOn')">
                                             <li
                                                *ngIf="!service.hideFromDevices || (allowHiddenAddOns && service.serviceGroupID)">
                                                <mat-checkbox [(ngModel)]="service.selected"
                                                   [ngModelOptions]="{standalone: true}"
                                                   [disabled]="service.serviceGroupID"
                                                   (ngModelChange)="updateAddOnServiceCheck($event, service)">
                                                   {{service.name}} <img *ngIf="checkDescription(service)"
                                                      src="assets/images/info-a-35.png" alt="info_image" height="15"
                                                      style="border-radius: 50%;" [matTooltip]="toolTipText"
                                                      matTooltipClass="web-appntment-toolTip"
                                                      (mouseenter)="getDescription(service)" />
                                                      &nbsp; <span class="tenant-text-color" *ngIf="selectedServiceMap[selectedReservationTypeID].showPricing && service.showPricing != false && service.price">({{service.price}})</span>
                                                </mat-checkbox>
                                                <section class="add-on-date-selector"
                                                   *ngIf="service.selected && datePickerType == 'Range'">
                                                   <label class="ml-4">How Often? :</label>
                                                   <mat-radio-group [(ngModel)]="service.isEveryDay"
                                                      [disabled]="service.serviceGroupID && (!selectedBundledAssociatedService || service.serviceGroupID != selectedBundledAssociatedService.id)"
                                                      [ngModelOptions]="{standalone: true}"
                                                      [ngModelOptions]="{standalone: true}"
                                                      (change)="dayTypeRadioChanged($event, service)">
                                                      <mat-radio-button [value]="false">Specific
                                                         Day(s)</mat-radio-button>
                                                      <mat-radio-button [value]="true">Every Day</mat-radio-button>
                                                   </mat-radio-group>
                                                   <section class="ml-5">
                                                      <mat-checkbox class="mr-3" [(ngModel)]="dateStr.checked"
                                                         [disabled]="service.serviceGroupID && (!selectedBundledAssociatedService || service.serviceGroupID != selectedBundledAssociatedService.id)"
                                                         [ngModelOptions]="{standalone: true}"
                                                         (change)="addOnServiceDateCheckChange($event, service)"
                                                         [ngModelOptions]="{standalone: true}"
                                                         *ngFor="let dateStr of service.dateList">
                                                         {{dateStr.value}}</mat-checkbox>
                                                   </section>
                                                </section>
                                             </li>
                                          </ng-container>
                                       </ng-container>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </mat-expansion-panel>
                     </ng-container>
                  </ng-container>
               </mat-accordion>

               <div class="clearfix" class="margin-t10">
                  <button class="btn btn-custom float-right next" [disabled]="isLoading || buttonDisabled"
                     (click)="nextStep($event, 'yourinfo')">Next<img src="assets/images/next.png" width="20px"
                        class="margin-l10" /></button>
               </div>
            </form>
            <!-- <button mat-button matStepperNext>Next</button> -->
            <form *ngIf="selectedPurchaseType != 'service'">
               <ng-template matStepLabel *ngIf="selectedPurchaseType == 'membership'">Membership</ng-template>
               <ng-template matStepLabel *ngIf="selectedPurchaseType == 'package'">Package</ng-template>
               <ng-template matStepLabel *ngIf="selectedPurchaseType == 'training'">Training</ng-template>
               <div class="form-group" *ngIf="app_android || app_ios">
                  <label class="card-title font-weight-bold mb-0 headeer">Purchase {{selectedPurchaseType ==
                     'membership'? 'memberships' : (selectedPurchaseType == 'package'? 'packages' : 'training
                     services')}} using our app!</label>
                  <div class="card-text">Download today to purchase the {{selectedPurchaseType == 'membership'?
                     'memberships' : (selectedPurchaseType == 'package'? 'packages' : 'training services')}}, manage
                     your profile, and much more!
                  </div>
                  <div class="mb-2 mt-4">
                     <a [href]="app_ios" target="_blank" *ngIf="app_ios">
                        <img src="assets/images/appStoreImg.png" alt="Pawops" height="40">
                     </a>
                     <a [href]="app_android" target="_blank" *ngIf="app_android">
                        <img src="assets/images/googlePlayImg.png" alt="Pawops" height="40">
                     </a>
                  </div>
               </div>

               <ng-container *ngIf="multiLocation.length > 1">

                  <label for="location" class="font-weight-bold headeer">Which location?</label>

                  <div class="form-group mb-0">

                     <mat-form-field appearance="outline">
                        <mat-label>Location</mat-label>
                        <mat-select [formControl]="locationCtrl" (selectionChange)="onLocationChangeNew($event)">
                           <mat-option *ngFor="let location of multiLocation" [value]="location?.locationKey">
                              {{location?.locationName}}
                           </mat-option>
                        </mat-select>

                        <mat-error *ngIf="locationCtrl.invalid">{{ getErrorMessage(locationCtrl, 'Location', 'required')
                           }}</mat-error>
                     </mat-form-field>
                  </div>

               </ng-container>
               <div class="form-group"
                  *ngIf="selectedPurchaseType == 'membership' || selectedPurchaseType == 'training'">
                  <label for="petType" class="font-weight-bold headeer">Pet type?</label>

                  <div id="petType" style="margin-top: 10px;">
                     <mat-button-toggle-group name="petType" aria-label="Pet Types" [(ngModel)]="selectedPetID"
                        [ngModelOptions]="{standalone: true}" (change)="onPetTypeChange($event)" required>
                        <mat-button-toggle *ngFor="let petType of petTypes | filter : filterValidPetTypeForMembeshipOrTraining.bind(this)" [value]="petType.id">
                           {{petType.name}}</mat-button-toggle>
                     </mat-button-toggle-group>
                  </div>
               </div>

               <div class="clearfix"
                  *ngIf="((selectedPurchaseType == 'membership' && this.membershipList.length>0 &&  isShowNextBtnAndTable()) || (selectedPurchaseType == 'package' &&  this.packageList.length>0) || (selectedPurchaseType == 'training' && this.trainingList.length>0 &&  isShowNextBtnAndTable()))">
                  <button class="btn btn-custom float-right next" [disabled]="isLoading || buttonDisabled"
                     (click)="nextStep($event, 'yourinfo')">Next<img src="assets/images/next.png" width="20px"
                        style="margin-left: 10px;" /></button>
               </div>

               <div class="form-group"
                  *ngIf="membershipList.length > 0 && selectedPurchaseType == 'membership' && isShowNextBtnAndTable()">
                  <label for="serviceType" class="font-weight-bold headeer">Which type of membership?</label>
                  <div id="serviceType">
                     <div style="display: flex; justify-content: space-between; width: 100%;padding: 0 24px;"
                        class="membership-header-mobile" *ngIf="isShowNextBtnAndTable()">
                        <span class="service-type" style="flex: 3;"> Name </span>
                        <span style="flex: 2;">Services/Qty</span>
                        <span class="flex-1" *ngIf="showMembershipFrequency">Duration</span>
                        <span style="flex:1;">Pet count</span>
                        <span style="flex: 2;text-align: center;">Price</span>
                        <span style="flex: 0;">Select</span>
                     </div>
                     <mat-accordion>
                        <ng-container *ngFor="let membership of membershipList">
                           <mat-expansion-panel [disabled]="value" #panel class="membership-no-arrow"
                              *ngIf="selectedPetID == membership.petTypeId"
                              [ngClass]="{'membership-dropdown-none': !((membership.genderAllowed && membership.genderAllowed != '') || (membership.petMinAge && membership.petMinAge != '') ||(membership.petEligibilityVo && membership.petEligibilityVo.length > 0) )}">
                              <mat-expansion-panel-header class="membership-expansion-panel-header"
                                 (click)="openPanel();onMembershipSelect($event, membership)"
                                 style="min-height:48px !important;height:auto !important;">
                                 <mat-panel-title
                                    style="display: flex; justify-content: space-between; width: 100%;margin-right: 0px !important;"
                                    class="membership-header-mobile">
                                    <div style="flex:1">
                                       <div class="service-icon"
                                          [ngClass]="{'hightlight-iconurl' : (membership.document && membership.document.id)}"
                                          *ngIf="membership.iconUrl"
                                          (click)="$event.preventDefault();showImages(membership)">
                                          <img src={{membership.iconUrl}} />
                                       </div>
                                       <div class="service-icon"
                                          [ngClass]="{'hightlight-iconurl' : (membership.document && membership.document.id)}"
                                          *ngIf="!membership.iconUrl"
                                          (click)="$event.preventDefault();showImages(membership)">
                                          <img src='https://itc-kennel.s3.amazonaws.com/kennel/services/default.png' />
                                       </div>
                                    </div>
                                    <span class="service-type" style="flex: 2;font-size: 15px;">
                                       {{membership.name}}
                                       <img *ngIf="checkDescription(membership)" src="assets/images/info-a-35.png"
                                          alt="info_image" height="15" style="border-radius: 50%;"
                                          [matTooltip]="toolTipText" matTooltipClass="web-appntment-toolTip"
                                          (mouseenter)="getDescription(membership)" />
                                    </span>
                                    <span style="flex: 2;font-size: 12px;">
                                       CREDIT : {{membership.maxCount == -1 ? 'UNLIMITED' : membership.maxCount}} <br>
                                       <span *ngIf="membership.services && membership.services.length > 0">
                                          <span *ngFor="let data of membership.serviceRules;index as i">
                                             <span *ngFor="let service of data.rule">
                                                {{service.name}} - {{service.quantity}}<br>
                                             </span>
                                             <span *ngIf="i != ( membership.serviceRules.length - 1)">
                                                <h5 style="margin:5px 0px !important">(OR)</h5>
                                             </span>
                                          </span>
                                       </span>
                                    </span>
                                    <span *ngIf="showMembershipFrequency" class="flex-1 font-size-13">{{membership.frequency != 'BIANNUALLY' ? membership.frequency : 'SEMI-ANNUAL'}}</span>
                                    <span style="flex: 1;text-align: center ;">{{membership.maxPetsAllowedOnPurchase ||
                                       ' '}}</span>
                                    <span style="flex: 2;text-align: center; "
                                       *ngIf="membership.reservationServices.service.priceTiers.length == 1">${{membership.reservationServices.service.priceTiers[0].amount.toFixed(2)}}
                                       <span *ngIf="membership.membershipBasis == 'PER_PET'"> <br> Per Pet</span>
                                    </span>
                                    <span style="flex: 2;font-size: 13px;text-align: center; "
                                       *ngIf="membership.reservationServices.service.priceTiers.length > 1">
                                       <div
                                          *ngFor="let price of membership.reservationServices.service.priceTiers;index as i"
                                          style="display: inline-block;">
                                          Pet {{i+1}} - ${{price.amount.toFixed(2)}}<br>
                                       </div>
                                    </span>
                                    <mat-radio-button (change)="openPanel();onMembershipSelect($event, membership)"
                                       [checked]="selectedMembership === membership"
                                       style="flex: 0;"></mat-radio-button>
                                    <span style="width:100%;display: none;" class="membership-credit-mobile">
                                       <span style="font-size: 13px;">
                                          CREDIT : {{membership.maxCount == -1 ? 'UNLIMITED' : membership.maxCount}}
                                          <br>
                                          <span *ngIf="membership.services && membership.services.length > 0">
                                             <span *ngFor="let data of membership.serviceRules;index as i">
                                                <span *ngFor="let service of data.rule">
                                                   {{service.name}} - {{service.quantity}}<br>
                                                </span>
                                                <span *ngIf="i != ( membership.serviceRules.length - 1)">
                                                   <h5 style="margin:5px 0px !important">(OR)</h5>
                                                </span>
                                             </span>
                                          </span>
                                       </span>
                                       <div *ngIf="showMembershipFrequency" class="font-size-13" >{{membership.frequency != 'BIANNUALLY' ?  membership.frequency : 'SEMI-ANNUAL'}}</div>
                                    </span>
                                 </mat-panel-title>
                              </mat-expansion-panel-header>
                              <mat-selection-list style="font-size: 17px;" class="membership-accordion">
                                 <ng-container>
                                    <p style="text-align: center;font-size: 18px;font-weight: 500;"
                                       *ngIf="(membership.genderAllowed && membership.genderAllowed != '') || (membership.petMinAge && membership.petMinAge != '') ||(membership.petEligibilityVo && membership.petEligibilityVo.length > 0)">
                                       Membership requirements for your pet</p>
                                    <div *ngIf="membership.petEligibilityVo && membership.petEligibilityVo.length > 0"
                                       style="flex-wrap: wrap; display: flex ;justify-content: center;gap :10px">
                                       <div *ngFor="let eligibility of membership.petEligibilityVo"
                                          style="padding: 10px; border: 1px dashed; margin-bottom: 10px;border-radius:5px;width:49%;background-color:white !important">
                                          <p *ngIf="eligibility.gendersInWords && eligibility.gendersInWords != ''"
                                             class="pet-eligibility-text">
                                             <span>Sex allowed</span>
                                             <span class="pet-eligibility-dot">:</span>
                                             <span class="pet-eligibility"> {{ eligibility.gendersInWords }}</span>
                                          </p>
                                          <p *ngIf="eligibility.ageInWords && eligibility.ageInWords != ''"
                                             class="pet-eligibility-text">
                                             <span>Age range </span>
                                             <span class="pet-eligibility-dot">:</span>
                                             <span class="pet-eligibility"> {{ eligibility.ageInWords }}</span>
                                          </p>
                                          <p *ngIf="eligibility.weightInWords && eligibility.weightInWords != '' "
                                             class="pet-eligibility-text">
                                             <span>Weight range </span>
                                             <span class="pet-eligibility-dot">:</span>
                                             <span class="pet-eligibility"> {{ eligibility.weightInWords}}</span>
                                          </p>
                                       </div>
                                    </div>
                                    <div *ngIf="!membership.petEligibilityVo || membership.petEligibilityVo.length == 0"
                                       style="padding: 10px; border: 1px dashed; margin-bottom: 10px;border-radius:5px;width:49%;background-color:white !important;margin:auto;">
                                       <p *ngIf="membership.genderAllowed && membership.genderAllowed != ''"
                                          class="pet-eligibility-text">
                                          <span>Sex allowed </span>
                                          <span class="pet-eligibility-dot">:</span>
                                          <span class="pet-eligibility"> {{membership.genderAllowed}} </span>
                                       </p>
                                       <p *ngIf="membership.petMinAge && membership.petMinAge != ''"
                                          class="pet-eligibility-text">
                                          <span>Minimum age </span>
                                          <span class="pet-eligibility-dot">:</span>
                                          <span class="pet-eligibility"> {{membership.petMinAge}} </span>
                                       </p>
                                    </div>
                                 </ng-container>
                              </mat-selection-list>
                           </mat-expansion-panel>
                        </ng-container>
                     </mat-accordion>
                  </div>
               </div>

               <div class="form-group" *ngIf="this.packageList.length>0 && selectedPurchaseType == 'package'">
                  <label for="serviceType" class="font-weight-bold headeer">Which type of package?</label>
                  <table mat-table [dataSource]="packageList" class="mat-elevation-z8 package-list"
                     style="width:100%; margin-bottom: 10px;margin-top: 10px;"
                     *ngIf="packageList && packageList.length >0">
                     <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.packageName}} <img
                              *ngIf="checkDescription(element)" src="assets/images/info-a-35.png" alt="info_image"
                              height="15" style="border-radius: 50%;" [matTooltip]="toolTipText"
                              matTooltipClass="web-appntment-toolTip" (mouseenter)="getDescription(element)" /> </td>
                     </ng-container>
                     <ng-container matColumnDef="services">
                        <th mat-header-cell *matHeaderCellDef> Services </th>
                        <td mat-cell *matCellDef="let element">
                           <span *ngIf="element.services && element.services.length > 0">
                              <span *ngFor="let data of element.serviceRules;index as i">
                                 <span *ngFor="let service of data.rule">
                                    {{service.name}} - {{service.quantity}}<br>
                                 </span>
                                 <span *ngIf="i != ( element.serviceRules.length - 1)">
                                    <h5 style="margin:5px 0px !important">(OR)</h5>
                                 </span>
                              </span>
                           </span>
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef> Price </th>
                        <td mat-cell *matCellDef="let element"> ${{element.price.toFixed(2)}} </td>
                     </ng-container>
                     <!-- <ng-container matColumnDef="tax">
                                                                  <th mat-header-cell *matHeaderCellDef> Tax % </th>
                                                                  <td mat-cell *matCellDef="let element"> {{element.tax || 0}} % </td>
                                                               </ng-container> -->
                     <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> Select </th>
                        <td mat-cell *matCellDef="let element"> <mat-radio-button name="package-select"
                              (change)="onPackageSelect($event, element)"></mat-radio-button> </td>
                     </ng-container>
                     <tr mat-header-row *matHeaderRowDef="packageColumns"></tr>
                     <tr mat-row *matRowDef="let row; columns: packageColumns;"></tr>
                  </table>
               </div>

               <div class="form-group"
                  *ngIf="this.trainingList.length>0 && selectedPurchaseType == 'training' && isShowNextBtnAndTable()">
                  <label for="trainingType" class="font-weight-bold headeer">Which type of training?</label>
                  <div id="trainingType">
                     <mat-accordion>
                        <ng-container *ngFor="let trainingService of trainingList">
                           <mat-expansion-panel [id]="'training-' + trainingService.id"
                              [expanded]="selectedTrainingType === trainingService.id"
                              (opened)="selectedTraining(trainingService)"
                              *ngIf="selectedPetID == trainingService.petType.id" [disabled]="sessionSelected" #panel>

                              <mat-expansion-panel-header>
                                 <mat-panel-title style="align-items:center;">
                                    <div class="service-icon"
                                       [ngClass]="{'hightlight-iconurl' : (trainingService.document && trainingService.document.id)}"
                                       (click)="$event.preventDefault();showImages(trainingService)"><img
                                          src={{trainingService.iconUrl}} /> </div>
                                    <span class="service-type">{{trainingService.name}}
                                       <img *ngIf="checkDescription(trainingService)" src="assets/images/info-a-35.png"
                                          alt="info_image" height="15" style="border-radius: 50%;"
                                          [matTooltip]="toolTipText" matTooltipClass="web-appntment-toolTip"
                                          (mouseenter)="getDescription(trainingService)" />
                                    </span>
                                    <!-- <span *ngIf="trainingService.priceTiers && trainingService.priceTiers.length > 0">  ${{trainingService.priceTiers[0].amount.toFixed(2)}}</span> -->
                                 </mat-panel-title>
                              </mat-expansion-panel-header>
                              <mat-selection-list #serviceSession [multiple]="true"
                                 (selectionChange)="onSessionChange($event,serviceSession)">
                                 <ng-container *ngFor="let session of trainingService.sessions">
                                    <div *ngIf="!session.hideFromDevices"
                                       [ngClass]="{'training-border' : (selectedSession && selectedSession.id == session.id)}">
                                       <mat-list-option [selected]="session.selected" [value]="session.id"
                                          class="session-list">
                                          <div style="display:flex;justify-content: space-between;"
                                             class="training-session-detail">
                                             <span>{{session.name}} <img
                                                   *ngIf="getTrainingSessionDescription(session,trainingService,'bool')"
                                                   src="assets/images/info-a-35.png" alt="info_image" height="15"
                                                   style="border-radius: 50%;" [matTooltip]="toolTipText"
                                                   matTooltipClass="web-appntment-toolTip-session"
                                                   (mouseenter)="getTrainingSessionDescription(session,trainingService,'text')" /></span>
                                             <span style="font-size: 14px;"><i>Classes : {{session.noOfAppointments}}
                                                   {{session.noOfAppointments > 1 ? 'classes' : 'class'}} </i></span>
                                             <span style="font-size: 14px;"
                                                *ngIf="trainingService.enrollmentType == 'FIXED_CLASS_SCHEDULE'"><i>Starts
                                                   at
                                                   {{getDateAndTime(session.recurringStartDate,'dateTime')}}</i></span>
                                          </div>
                                       </mat-list-option>
                                       <div style="padding: 17px 35px 5px "
                                          *ngIf="selectedSession && selectedSession.id == session.id"
                                          class="training-requirement-card">
                                          <p style="font-size: 18px;font-weight: 500;">Class Details</p>
                                          <p *ngIf="session.durationInText && session.durationInText != ''">Duration :
                                             {{session.durationInText}}</p>
                                          <div *ngIf="trainingService.enrollmentType == 'FIXED_CLASS_SCHEDULE'">
                                             <p *ngFor="let classes of session.classes">
                                                {{classes.name}} - {{getDateAndTime(classes.appointmentDate,
                                                'dateTime')}}
                                             </p>
                                          </div>
                                          <div *ngIf="trainingService.enrollmentType != 'FIXED_CLASS_SCHEDULE'">
                                             <p *ngFor="let classes of session.groupedClasses">
                                                {{classes.name}}
                                             </p>
                                          </div>
                                          <hr
                                             *ngIf="(session.genderAllowed && session.genderAllowed != '') || (session.petMinAge && session.petMinAge != '') || (session.weightFrom &&  session.weightTo) ">
                                          <p *ngIf="(session.genderAllowed && session.genderAllowed != '') || (session.petMinAge && session.petMinAge != '') || (session.weightFrom &&  session.weightTo) "
                                             style="font-size: 18px;font-weight: 500;">Session requirements for your pet
                                          </p>
                                          <p *ngIf="session.genderAllowed && session.genderAllowed != ''">Pet genders
                                             allowed : {{session.genderAllowed}}</p>
                                          <p *ngIf="session.petMinAge && session.petMinAge != ''">Pet minimum age :
                                             {{session.petMinAge}}</p>
                                          <p *ngIf="session.weightFrom &&  session.weightTo">Pet weight :
                                             {{session.weightFrom}} - {{session.weightTo}} lbs</p>
                                       </div>
                                    </div>
                                 </ng-container>
                                 <ng-container *ngIf="trainingService.sessions && trainingService.sessions.length == 0">
                                    <p class="mt-1 ml-2" style="text-align:center"> No sessions
                                       available</p>
                                 </ng-container>
                              </mat-selection-list>
                           </mat-expansion-panel>
                        </ng-container>
                     </mat-accordion>
                  </div>
               </div>

               <div class="clearfix"
                  *ngIf="((selectedPurchaseType == 'membership' && this.membershipList.length>0 &&  isShowNextBtnAndTable()) || (selectedPurchaseType == 'package' &&  this.packageList.length>0) || (selectedPurchaseType == 'training' && this.trainingList.length>0 &&  isShowNextBtnAndTable()))">
                  <button class="btn btn-custom float-right next" [disabled]="isLoading || buttonDisabled"
                     (click)="nextStep($event, 'yourinfo')">Next<img src="assets/images/next.png" width="20px"
                        style="margin-left: 10px;" /></button>
               </div>
            </form>
         </mat-step>

         <mat-step>
            <ng-template matStepLabel>Your Info</ng-template>
            <!-- <div style="display: flex; justify-content: center;">
               <button (click)="socialLogin()" class="btn btn-custom">Social Login</button>
            </div>
            <div class="astrodivider">
               <div class="astrodividermask"></div><span><i>OR</i></span>
            </div> -->

            <ng-container *ngIf="showOtpInput">
               <p class="sub-text text-a-c" style="font-size: 20px;">
                Check your <span *ngIf="unAuthorizedUser?.mobileNumber && !isEmailPreferred">text messages</span> <span *ngIf="unAuthorizedUser?.email">Email</span>
               </p>
               <div class ="otp_input">
                  <div>
                     <mat-icon style="font-size: 60px;color: gray;transform: translateX(-14px);" *ngIf="unAuthorizedUser?.mobileNumber && !isEmailPreferred">sms</mat-icon>
                     <mat-icon style="font-size: 60px;color: gray;transform: translateX(-14px);" *ngIf="unAuthorizedUser?.email">mail</mat-icon>
                  </div>
               </div>
               
               <div style="width: 350px;margin: auto; margin-bottom: 2rem;">
                  <p class="sub-text" style="text-align: center;">Enter the verification code we sent you to verify your identity</p> 
                  <p class="sub-text" style="margin-bottom: 4px;">We sent code to:</p>
                  <span *ngIf="unAuthorizedUser?.email" style="font-size: 16px;">{{maskEmail(unAuthorizedUser.email)}}</span>
                  <span *ngIf="unAuthorizedUser?.mobileNumber && !isEmailPreferred" style="font-size: 16px;">{{maskPhone(unAuthorizedUser.mobileNumber)}}</span>
                  <br>
                  <p class="sub-text" style="margin-top: 8px;margin-bottom: 8px !important;">Enter 6-digit code</p>
                  <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{ length: 6,allowNumbersOnly:true }"></ng-otp-input>
               </div>
               

               <p *ngIf="otpErrorMsg" class="warntext">{{otpErrorMsg}}</p>
               
               <div class="otp_input" *ngIf="!isLoading">
                 <button class="btn btn-custom" [disabled]="isResendDisabled || buffer" (click)="resendOtp(false)">
                  I didn't get a 
                  <span *ngIf="unAuthorizedUser?.mobileNumber && !isEmailPreferred">text message</span> <span *ngIf="unAuthorizedUser?.email">Email</span>
                  <span *ngIf="isResendDisabled"> {{ remainingTime }}s</span>
                 </button>
                 <p class="email-resend" *ngIf="unAuthorizedUser?.mobileNumber && userAuthAction == 'SIGN_IN' && !isEmailPreferred" (click)="sendOtpToEmail()">Email me instead</p>
               </div>
            </ng-container>

            <!-- Sign Up & Sign In  -->

            <div *ngIf="!showOtpInput">
               <form *ngIf="!showForget">
                  <h3 for="return-customer" class="font-weight-bold headeer">Returning Customers</h3>
                  <span style="font-size: 14px;">(If you have already visited or if your information has already been given to the facility)</span>
                  <div id="return-customer" style="display: flex;" class="m-flex-col">
                     <div style="display: grid;">
                        <mat-form-field appearance="outline">
                           <mat-label>Email <span>*</span></mat-label>
                           <input matInput placeholder="Ex. example@email.com" [formControl]="existEmailCtrl" oninput="this.value = this.value.toLowerCase()">
                           <mat-icon matSuffix>email</mat-icon>
                           <mat-error *ngIf="existEmailCtrl.invalid">{{getErrorMessage(existEmailCtrl, 'Email address',
                              'pattern', 'required')}}</mat-error>
                        </mat-form-field>
                        <p *ngIf="returnUserEmailEmpty" class="mb-2" style="color: red;">{{returnUserEmailEmpty}}</p>
                     </div>
                     <div style="display: grid;">
                        <mat-form-field appearance="outline">
                           <mat-label>Password <span>*</span></mat-label>
                           <input matInput [type]="hidePass ? 'password' : 'text'" [formControl]="existPassCtrl">
                           <button mat-icon-button matSuffix (click)="hidePass = !hidePass"
                              [attr.aria-label]="'Hide Password'" [attr.aria-pressed]="hidePass">
                              <mat-icon>{{hidePass ? 'visibility_off' : 'visibility'}}</mat-icon>
                           </button>
                           <mat-error *ngIf="existPassCtrl.invalid">{{getErrorMessage(existPassCtrl, 'Password', 'required')}}
                           </mat-error>
                        </mat-form-field>
                        <mat-error *ngIf="returnUserPassEmpty" class="mb-2">{{returnUserPassEmpty}}</mat-error>
                     </div>
                     <mat-error *ngIf="loginErrMsg" class="mb-2">{{loginErrMsg}}</mat-error>
                  </div>
                  <div class="clearfix">
                     <button class="btn btn-custom float-right" [disabled]="isLoading || buttonDisabled"
                        (click)="checkReturnUserEmpty();nextStep($event,'signin')">Sign In</button>
                  </div>
                  <div class="clearfix">
                     <a href="javascript:;" class="ml-2 text-muted float-right" (click)="showForgetPassword(true)">Forgot
                        Password?</a>
                  </div>
               </form>
   
               <div class="astrodivider" *ngIf="!showForget">
                  <div class="astrodividermask"></div><span><i>OR</i></span>
               </div>
   
               <form autocomplete="off" *ngIf="!showForget">
                  <h3 for="new-customer" class="font-weight-bold headeer">New Customers</h3>
                  <h3 for="return-customer" class="font-weight-bold headeer">Do you have an invite code from
                     {{location?.locationName}}?</h3>
                  <p>Note: For first time sign up only</p>
                  <mat-form-field appearance="outline" class="m-w-100P">
                     <mat-label>Invite Code <span>*</span> </mat-label>
                     <!-- <textarea matInput rows="3" [formControl]="inviteCodeCtrl"></textarea> -->
                     <input matInput type="text" [formControl]="inviteCodeCtrl"/>
                     <mat-error *ngIf="inviteCodeCtrl.invalid">{{getErrorMessage(inviteCodeCtrl, 'Invite Code',
                        'required')}}</mat-error>
                  </mat-form-field>
                  <mat-error *ngIf="inviteCodeErrMsg" class="mb-2">{{inviteCodeErrMsg}}</mat-error>
   
   
   
                  <mat-form-field appearance="outline" *ngIf="showPasswordFieldForInviteCode" class="m-w-100P">
                     <mat-label>Create a password <span>*</span></mat-label>
                     <input matInput [type]="hidePasswordForInviteCode ? 'password' : 'text'"
                        [formControl]="inviteCodePasswordCtrl" >
                     <button mat-icon-button matSuffix (click)="hidePasswordForInviteCode = !hidePasswordForInviteCode"
                        [attr.aria-label]="'Hide Password'" [attr.aria-pressed]="hidePasswordForInviteCode">
                        <mat-icon>{{hidePasswordForInviteCode ? 'visibility_off' : 'visibility'}}</mat-icon>
                     </button>
                     <mat-error *ngIf="inviteCodePasswordCtrl.invalid">{{getErrorMessage(inviteCodePasswordCtrl,
                        'Password', 'required')}}</mat-error>
                     <mat-error *ngIf="inviteCodePasswordCtrl.hasError('pattern')" style="margin-bottom:10px">Password must contain at least one
                        lowercase letter, one uppercase letter, one numeric digit, and be at least 8 characters
                        long</mat-error>
                  </mat-form-field>
                  <mat-error *ngIf="inviteCodePasswordErrMsg" class="mb-2">{{inviteCodePasswordErrMsg}}</mat-error>
   
                  <div class="clearfix" *ngIf="!showPasswordFieldForInviteCode">
                     <button class="btn btn-custom float-right" (click)="checkInviteCodeEmpty();checkInviteCode()">Continue</button>
                  </div>
   
                  <div class="clearfix" *ngIf="showPasswordFieldForInviteCode">
                     <button class="btn btn-custom float-right" (click)="checkInviteCodeWithPassword();nextStep($event,'invite')">Continue</button>
                  </div>
               </form>
   
               <div class="astrodivider" *ngIf="!showForget && !showSignUp">
                  <div class="astrodividermask"></div><span><i>OR</i></span>
               </div>
   
               <form *ngIf="!showForget && !showSignUp">
                  <h3 for="new-customer" class="font-weight-bold headeer">New Customers</h3>
                  <ng-container>
                     <div id="new-customer">
                        <div style="display: flex;" class="m-flex-col">
                           <div style="display: grid;">
                              <mat-form-field appearance="outline">
                                 <mat-label>First name <span>*</span></mat-label>
                                 <input matInput placeholder="First Name" [formControl]="firstNameCtrl"
                                    (keyup)="onNameChange($event, firstNameCtrl)" >
                                 <mat-icon matSuffix>person</mat-icon>
                                 <mat-error *ngIf="firstNameCtrl.invalid">{{getErrorMessage(firstNameCtrl, 'First Name',
                                    'specialchar', 'iscapital', 'required')}}</mat-error>
                              </mat-form-field>
                              <p *ngIf="firstNameEmpty" class="mb-2" style="color: red;">{{firstNameEmpty}}
                           </div>
                           <div style="display: grid;">
                              <mat-form-field appearance="outline">
                                 <mat-label>Last name <span>*</span></mat-label>
                                 <input matInput placeholder="Last Name" [formControl]="lastNameCtrl"
                                    (keyup)="onNameChange($event, lastNameCtrl)" >
                                 <mat-icon matSuffix>person</mat-icon>
                                 <mat-error *ngIf="lastNameCtrl.invalid">{{getErrorMessage(lastNameCtrl, 'Last Name', 'specialchar',
                                    'iscapital', 'required')}}</mat-error>
                              </mat-form-field>
                              <p *ngIf="lastNameEmpty" class="mb-2" style="color: red;">{{lastNameEmpty}}
                           </div>
                        </div>
                        <div style="display: flex;" class="m-flex-col">
                           <div style="display: grid;">
                              <mat-form-field appearance="outline">
                                 <mat-label>Phone <span>*</span></mat-label>
                                 <input matInput type="tel" placeholder="Ex. 555-555-1234" [formControl]="phoneCtrl"
                                    mask="(000) 000-0000" [showMaskTyped]="true">
                                 <mat-icon matSuffix>phone</mat-icon>
                                 <mat-error *ngIf="phoneCtrl.invalid">{{getErrorMessage(phoneCtrl, 'Phone Number', 'pattern',
                                    'required')}}</mat-error>
                              </mat-form-field>
                              <p *ngIf="phoneEmpty" class="mb-2" style="color: red;">{{phoneEmpty}}
                           </div>
                           <div style="display: grid;">
                              <mat-form-field appearance="outline">
                                 <mat-label>Email <span>*</span></mat-label>
                                 <input matInput placeholder="Ex. example@email.com" [formControl]="newEmailCtrl" oninput="this.value = this.value.toLowerCase()">
                                 <mat-icon matSuffix>email</mat-icon>
                                 <mat-error *ngIf="newEmailCtrl.invalid">{{getErrorMessage(newEmailCtrl, 'Email address', 'pattern',
                                    'required')}}</mat-error>
                              </mat-form-field>
                              <p *ngIf="newEmailEmpty" class="mb-2" style="color: red;">{{newEmailEmpty}}
                           </div>
                        </div>
                        <div class="m-d-grid">
                              <mat-form-field appearance="outline">
                                 <mat-label>Create a password <span>*</span></mat-label>
                                 <input matInput [type]="hidePass ? 'password' : 'text'" [formControl]="newPassCtrl" >
                                 <button mat-icon-button matSuffix (click)="hidePass = !hidePass"
                                    [attr.aria-label]="'Hide Password'" [attr.aria-pressed]="hidePass">
                                    <mat-icon>{{hidePass ? 'visibility_off' : 'visibility'}}</mat-icon>
                                 </button>
                                 <mat-error *ngIf="newPassCtrl.invalid">{{getErrorMessage(newPassCtrl, 'Password', 'required')}}
                                    <mat-error *ngIf="newPassCtrl.hasError('pattern')">Password must contain at least one lowercase
                                       letter, one uppercase letter, one numeric digit, and be at least 8 characters
                                       long</mat-error>
                                 </mat-error>
                              </mat-form-field>
                              <p *ngIf="newPassEmpty" class="mb-2" style="color: red;">{{newPassEmpty}}</p>
                        </div>
                        <div style="margin-top: 30px;">
                           <div style="display: grid;">
                              <mat-form-field appearance="outline">
                                 <mat-label>Type the street address for google auto-type or manually enter <span>*</span></mat-label>
                                 <input matInput placeholder="search for location" #searchGoogleAddressInput [formControl]="newStreetCtrl" (change)="googlePlacesSearch()" />
                              </mat-form-field>
                              <p *ngIf="streetAddressEmpty" class="mb-2" style="color: red;">{{streetAddressEmpty}}</p>
                           </div>
                        </div>
                        <div style="display: flex;" class="m-flex-col">
                           <div style="display: grid;">
                              <mat-form-field appearance="outline">
                                 <mat-label>City <span>*</span></mat-label>
                                 <input matInput placeholder="Enter your city" [formControl]="newCityCtrl"/>
                              </mat-form-field>
                              <p *ngIf="newCityEmpty" class="mb-2" style="color: red;">{{newCityEmpty}}</p>
                           </div>
                           <div style="display: grid;">
                              <mat-form-field appearance="outline">
                                 <mat-label>State  <span>*</span></mat-label>
                                 <input matInput placeholder="Enter your state" [formControl]="newStateCtrl" />
                              </mat-form-field>
                              <p *ngIf="newStateEmpty" class="mb-2" style="color: red;">{{newStateEmpty}}</p>
                           </div>
                           <div style="display: grid;">
                              <mat-form-field appearance="outline">
                                 <mat-label>{{(location && location.country === 'CA') ? 'Postal code' : 'Zip code'}} <span>*</span></mat-label>
                                 <input matInput [placeholder]="(location && location.country === 'CA') ? 'Enter your postal code (A1A 1A1)' : 'Enter your zip code'" (input)="enforceZipCodeFormat($event,'newZipCtrl')"  [formControl]="newZipCtrl"/>
                              </mat-form-field>
                              <p *ngIf="newZipEmpty" class="mb-2" style="color: red;">{{newZipEmpty}}</p>
                           </div>
                        </div>
                        <mat-error *ngIf="signupErrMsg" class="mb-2">{{signupErrMsg}}</mat-error>
                     </div>
                  </ng-container>
   
                  <div class="clearfix mt-5">
                        <button class="btn btn-custom float-right" [disabled]="isLoading || buttonDisabled"
                           (click)="checkNewUserEmpty();nextStep($event, 'signup')">Sign Up</button>
                        <button class="btn btn-custom float-left" [disabled]="isLoading || buttonDisabled" (click)="goBack('customerData')">Back</button>
                  </div>
               
               </form>
            </div>
            

            <div class="clearfix noCondition-btn" *ngIf="showSignUp">
               <button class="btn btn-custom float-left" [disabled]="isLoading || buttonDisabled" (click)="goBack('customerData')">Back</button>
            </div>

            <form *ngIf="showForget">
               <h3 for="forget-password" class="font-weight-bold headeer">Forgot Password</h3>
               <p> Please enter the email address you registerd with. If you have an account with us, we will send you
                  an email with
                  a link to reset your password.</p>
               <div id="forget-password">
                  <mat-form-field appearance="outline" [disabled]="forgetsucess">
                     <mat-label>Email</mat-label>
                     <input matInput placeholder="Ex. example@email.com" [formControl]="existEmailCtrl" required
                        oninput="this.value = this.value.toLowerCase()">
                     <mat-icon matSuffix>email</mat-icon>
                     <mat-error *ngIf="existEmailCtrl.invalid">
                        {{getErrorMessage(existEmailCtrl, 'Email address', 'pattern', 'required')}}</mat-error>
                  </mat-form-field>
                  <mat-error *ngIf="loginErrMsg" class="mb-2">{{loginErrMsg}}</mat-error>
                  <h3 *ngIf="forgetsucess" class="font-weight-bold">{{forgetsuccessMsg}}</h3>
               </div>
               <div class="clearfix">
                  <button class="btn btn-custom float-right" *ngIf="forgetsucess" [disabled]="isLoading || buttonDisabled"
                     (click)="goBackForForgetPassword(false)">Start over</button>
                  <button class="btn btn-custom float-right" *ngIf="!forgetsucess" [disabled]="isLoading || buttonDisabled"
                     (click)="nextStep($event,'forget')">Send link</button>
                  <button class="btn btn-custom float-left" *ngIf="!forgetsucess" [disabled]="isLoading || buttonDisabled"
                     (click)="goBackForForgetPassword(true)">Back</button>
               </div>
            </form>

         </mat-step>

         <mat-step
            *ngIf="selectedPurchaseType == 'service' || selectedPurchaseType == 'membership' || selectedPurchaseType == 'training'">

            <ng-template matStepLabel>Pet Info</ng-template>

            <ng-container>
               <div *ngIf="petOwnerMandatory && (petOwnerMandatory.requireMobile || petOwnerMandatory.requireEmail)">
                  <div class="row">
                     <h3 for="whoFor" class="col-6 font-weight-bold headeer">Required Pet Owner Info</h3>
                  </div>
                  <div style="display: flex;" class="pet-owner-info-container">
                     <div style="display: grid;" *ngIf="petOwnerMandatory && petOwnerMandatory.requireMobile">
                        <mat-form-field appearance="outline">
                           <mat-label>Phone <span>*</span></mat-label>
                           <input matInput type="tel" placeholder="Ex. 555-555-1234" mask="(000) 000-0000"
                              [(ngModel)]="petOwnerMandatory.phoneNumber" [showMaskTyped]="true">
                           <mat-icon matSuffix>phone</mat-icon>
                           <mat-error *ngIf="phoneCtrl.invalid">{{getErrorMessage(phoneCtrl, 'Phone Number', 'pattern',
                              'required')}}</mat-error>
                        </mat-form-field>
                        <p *ngIf="phoneEmpty" class="mb-2" style="color: red;">{{phoneEmpty}}
                     </div>
                     <div style="display: grid;" *ngIf="petOwnerMandatory && petOwnerMandatory.requireEmail">
                        <mat-form-field appearance="outline">
                           <mat-label>Email <span>*</span></mat-label>
                           <input matInput placeholder="Ex. example@email.com" [(ngModel)]="petOwnerMandatory.email"
                              oninput="this.value = this.value.toLowerCase()">
                           <mat-icon matSuffix>email</mat-icon>
                           <mat-error *ngIf="newEmailCtrl.invalid">{{getErrorMessage(newEmailCtrl, 'Email address',
                              'pattern',
                              'required')}}</mat-error>
                        </mat-form-field>
                        <p *ngIf="newEmailEmpty" class="mb-2" style="color: red;">{{newEmailEmpty}}
                     </div>
                  </div>
               </div>

               <div
                  *ngIf="petOwnerMandatory && (petOwnerMandatory.requireEmergency || petOwnerMandatory.requireAuthorized)">
                  <div class="row">
                     <h3 for="whoFor" class="col-6 font-weight-bold headeer"><span
                           *ngIf="petOwnerMandatory && petOwnerMandatory.requireEmergency"> Emergency </span> <span
                           *ngIf="petOwnerMandatory.requireEmergency && petOwnerMandatory.requireAuthorized"> and
                        </span> <span *ngIf="petOwnerMandatory && petOwnerMandatory.requireAuthorized"> Authorized
                        </span> Contact <span style="color:red">*</span></h3>
                  </div>
                  <div style="display: flex;justify-content: space-around;" class="pet-owner-info-container"
                     *ngIf="petOwnerMandatory && petOwnerMandatory.requireEmergency">
                     <div style="display: grid;">
                        <mat-form-field appearance="outline">
                           <mat-label>Emergency Name <span>*</span></mat-label>
                           <input matInput placeholder="Emergency Name" [(ngModel)]="petOwnerMandatory.emergencyName" />
                        </mat-form-field>
                        <p *ngIf="newCityEmpty" class="mb-2" style="color: red;">{{newCityEmpty}}</p>
                     </div>
                     <div style="display: grid;">
                        <mat-form-field appearance="outline" class="pet-owner-emergency">
                           <mat-label>Emergency Phone <span>*</span></mat-label>
                           <input matInput type="tel" placeholder="Ex. 555-555-1234" mask="(000) 000-0000"
                              [(ngModel)]="petOwnerMandatory.emergencyPhone" [showMaskTyped]="true">
                           <mat-icon matSuffix>phone</mat-icon>
                           <mat-error *ngIf="phoneCtrl.invalid">{{getErrorMessage(phoneCtrl, 'Phone Number', 'pattern',
                              'required')}}</mat-error>
                        </mat-form-field>
                        <p *ngIf="phoneEmpty" class="mb-2" style="color: red;">{{phoneEmpty}}
                     </div>
                     <div style="display: grid;">
                        <mat-form-field appearance="outline" class="pet-owner-emergency">
                           <mat-label>Emergency Email <span>*</span></mat-label>
                           <input matInput placeholder="Ex. example@email.com"
                              [(ngModel)]="petOwnerMandatory.emergencyEmail"
                              oninput="this.value = this.value.toLowerCase()">
                           <mat-icon matSuffix>email</mat-icon>
                           <mat-error *ngIf="newEmailCtrl.invalid">{{getErrorMessage(newEmailCtrl, 'Email address',
                              'pattern',
                              'required')}}</mat-error>
                        </mat-form-field>
                        <p *ngIf="newEmailEmpty" class="mb-2" style="color: red;">{{newEmailEmpty}}
                     </div>
                  </div>
                  <div style="display: flex;justify-content: space-around;" class="pet-owner-info-container"
                     *ngIf="petOwnerMandatory && petOwnerMandatory.requireAuthorized">
                     <div style="display: grid;">
                        <mat-form-field appearance="outline">
                           <mat-label>Authorized Name <span>*</span></mat-label>
                           <input matInput placeholder="Authorized Name"
                              [(ngModel)]="petOwnerMandatory.authorizedName" />
                        </mat-form-field>
                        <p *ngIf="newCityEmpty" class="mb-2" style="color: red;">{{newCityEmpty}}</p>
                     </div>
                     <div style="display: grid;">
                        <mat-form-field appearance="outline" class="pet-owner-emergency">
                           <mat-label>Authorized Phone <span>*</span></mat-label>
                           <input matInput type="tel" placeholder="Ex. 555-555-1234" mask="(000) 000-0000"
                              [(ngModel)]="petOwnerMandatory.authorizedPhone" [showMaskTyped]="true">
                           <mat-icon matSuffix>phone</mat-icon>
                           <mat-error *ngIf="phoneCtrl.invalid">{{getErrorMessage(phoneCtrl, 'Phone Number', 'pattern',
                              'required')}}</mat-error>
                        </mat-form-field>
                        <p *ngIf="phoneEmpty" class="mb-2" style="color: red;">{{phoneEmpty}}
                     </div>
                     <div style="display: grid;">
                        <mat-form-field appearance="outline" class="pet-owner-emergency">
                           <mat-label>Authorized Email <span>*</span></mat-label>
                           <input matInput placeholder="Ex. example@email.com"
                              [(ngModel)]="petOwnerMandatory.authorizedEmail"
                              oninput="this.value = this.value.toLowerCase()">
                           <mat-icon matSuffix>email</mat-icon>
                           <mat-error *ngIf="newEmailCtrl.invalid">{{getErrorMessage(newEmailCtrl, 'Email address',
                              'pattern',
                              'required')}}</mat-error>
                        </mat-form-field>
                        <p *ngIf="newEmailEmpty" class="mb-2" style="color: red;">{{newEmailEmpty}}
                     </div>
                  </div>
               </div>

               <div [hidden]="!showAddressField">
                  <div class="row">
                     <h3 for="whoFor" class="col-6 font-weight-bold headeer">Address Required <span
                           style="color:red">*</span></h3>
                  </div>
                  <form autocomplete="off" style="padding: 20px;">
                     <div>
                        <div style="display: grid;">
                           <mat-form-field appearance="outline" style="margin: 0px !important;">
                              <mat-label>Type the street address for google auto-type or manually enter
                                 <span>*</span></mat-label>
                              <input id=searchGoogleAddressInputInvite matInput placeholder="search for location"
                                 [formControl]="inviteStreetCtrl" (change)="googlePlacesSearchInvite()" />
                           </mat-form-field>
                           <p *ngIf="inviteStreetEmpty" class="mb-2" style="color: red;">{{inviteStreetEmpty}}</p>
                        </div>
                     </div>
                     <div style="display: flex;" class="pet-owner-info-container">
                        <div style="display: grid;">
                           <mat-form-field appearance="outline">
                              <mat-label>City <span>*</span></mat-label>
                              <input matInput placeholder="Enter your city" [formControl]="inviteCityCtrl" />
                           </mat-form-field>
                           <p *ngIf="inviteCityEmpty" class="mb-2" style="color: red;">{{inviteCityEmpty}}</p>
                        </div>
                        <div style="display: grid;">
                           <mat-form-field appearance="outline">
                              <mat-label>State <span>*</span></mat-label>
                              <input matInput placeholder="Enter your state" [formControl]="inviteStateCtrl" />
                           </mat-form-field>
                           <p *ngIf="inviteStateEmpty" class="mb-2" style="color: red;">{{inviteStateEmpty}}</p>
                        </div>
                        <div style="display: grid;">
                           <mat-form-field appearance="outline">
                              <mat-label>{{(location && location.country === 'CA') ? 'Postal code' : 'Zip code'}} <span>*</span></mat-label>
                              <input matInput [placeholder]="(location && location.country === 'CA') ? 'Enter your postal code (A1A 1A1)' : 'Enter your zip code'" (input)="enforceZipCodeFormat($event,'inviteZipCtrl')"  [formControl]="inviteZipCtrl" />
                           </mat-form-field>
                           <p *ngIf="inviteZipEmpty" class="mb-2" style="color: red;">{{inviteZipEmpty}}</p>
                        </div>
                     </div>
                  </form>
               </div>

               <div class="row" style="display: none;"
                  *ngIf="showAddressField || (petOwnerMandatory && (petOwnerMandatory.requireMobile || petOwnerMandatory.requireEmail || petOwnerMandatory.requireEmergency || petOwnerMandatory.requireAuthorized))">
                  <div class="col"></div>
                  <div class="col">
                     <button type="button" class="btn btn-custom" style="float:right;margin-bottom: 10px;"
                        (click)="validateUserAddress('save');">Save</button>
                  </div>
               </div>
            </ng-container>

            <div class="form-group" *ngIf="pageShowType == 'showpets' && selectedPurchaseType == 'service'">
               <div class="row">
                  <h3 for="whoFor" class="col-6 font-weight-bold headeer">My Services</h3>
                  <h3 for="whoFor" class="col-6 font-weight-bold headeer">My Pets</h3>
               </div>
               <div class="row mt-3" *ngFor="let petService of petServiceMap;let petIdx=index;">
                  <div class="col-md-6 col-xd-6 col-lg-6">
                     <mat-card class="pet-service-card">
                        <mat-card-header class="justify-content-center">
                           <mat-card-title class="text-center">Pet #{{petIdx+1}}</mat-card-title>
                           <mat-card-subtitle class="text-center mb-0">Service List</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                           <mat-list>
                              <div *ngFor="let service of petService.services | keyvalue">
                                 <mat-list-item>{{service.value.service.name}}</mat-list-item>
                                 <mat-list-item
                                    *ngIf="service.value.basedOn=='STAFF_BASED' && service.value.showStaff==true">
                                    <div *ngIf="service.value.timeSlot.selectedEmployee">
                                       Requested Staff: {{service.value.timeSlot.selectedEmployee.firstName}}
                                       {{service.value.timeSlot.selectedEmployee.lastName}}
                                    </div>
                                 </mat-list-item>
                                 <mat-list-item *ngFor="let addOn of service.value.addOn | filter: filterSelected">
                                    {{addOn.name}}</mat-list-item>
                              </div>
                              <mat-form-field appearance="outline"
                                 style="margin-right: 0px !important; width: 100%; margin: 10px 0px 10px 0px;">
                                 <mat-label>Additional notes</mat-label>
                                 <textarea matInput placeholder="" [(ngModel)]="petService.notes"></textarea>
                              </mat-form-field>
                           </mat-list>
                        </mat-card-content>
                     </mat-card>
                  </div>

                  <div class="col-md-6 col-xd-6 col-lg-6 d-block align-items-center">
                     <div> <button class="btn btn-custom float-right mr-10 m-m-15" (click)="showAddPet()"
                           style="margin-bottom: 10px;">Add
                           Pet</button></div><br>
                     <mat-form-field appearance="outline">
                        <mat-label>Assign Pet</mat-label>
                        <mat-select #assignedPet
                           (selectionChange)="onAssignPet($event, petService, petIdx, assignedPet)"
                           [(ngModel)]="petServiceMap[petIdx]['pet']" required [compareWith]="comparePets">
                           <mat-option *ngFor="let userPet of userPets | filter: filterActive" [value]="userPet">
                              {{userPet.name}}
                           </mat-option>
                           <mat-option (click)="showAddPet()"><a href="javascript:;" class="ml-2 text-muted"
                                 [disabled]="isLoading || buttonDisabled">Add Pet</a></mat-option>
                        </mat-select>
                     </mat-form-field>
                  </div>
               </div>
               <!-- <div id="whoFor">
                  <div class="btn-group select-pet-btn-group">
                     <label class="btn btn-checkbox" *ngFor="let userPet of userPets" [(ngModel)]="userPet.selected"
                        btnCheckbox tabindex="0" role="button">{{userPet.name}}</label>
                  </div>
               </div>
               <div>

              </div> -->
            </div>
            <div class="clearfix" *ngIf="pageShowType == 'showpets' && selectedPurchaseType == 'service'">
               <button class="btn btn-custom float-right next" [disabled]="isLoading || buttonDisabled"
                  (click)="validateUserAddress('save');nextStep($event, 'confirm')">Confirm <img
                     src="assets/images/next.png" width="20px" style="margin-left: 10px;" /></button>
               <button class="btn btn-custom float-left" [disabled]="isLoading || buttonDisabled"
                  (click)="goBack('petInfo')">Back</button>
            </div>
            <div class="form-group" *ngIf="pageShowType == 'showpets' && selectedPurchaseType != 'service'">
               <div class="row">
                  <h3 for="whoFor" class="col-6 font-weight-bold headeer">Select Pets</h3>
                  <div class="col">
                     <button class="btn btn-custom float-right " (click)="showAddPet()">Add New Pet</button>
                  </div>
               </div>
               <div class="row">
                  <div class="col-md-4 col-xd-4 col-lg-4" *ngFor="let pet of userPets">
                     <div class="card mat-button-toggle-checked"
                        style="margin-top: 10px;border-radius: 20px;min-height:320px" *ngIf="pet.selected"
                        (click)="onMembershipPetChange(pet)">
                        <div class="card-body " style="text-align: center;cursor: pointer;padding: 0px !important;">
                           <img
                              *ngIf="!pet.document || !pet.document.attachments || pet.document.attachments.length == 0"
                              src="assets/images/dog-placeholder.png"
                              class="pet-image mt-10">
                           <img
                              *ngIf="pet.document && pet.document.attachments && pet.document.attachments.length > 0 && pet.document.attachments[0].url"
                              src="{{pet.document.attachments[0].url}}" class="pet-image ">
                           <div style=" padding: 10px;">
                              <h5 class="card-title " style="font-size: 18px;">{{pet.name}}</h5>
                              <p *ngIf="pet.breed" class="pet-eligibility-text text-left">
                                 <span style="width:30%">Breed</span>
                                 <span class="pet-eligibility-dot">:</span>
                                 <span style="width:68%;color:white;" class="pet-eligibility  text-left">
                                    {{pet.breed.name}}</span>
                              </p>
                              <p *ngIf="pet.gender" class="pet-eligibility-text text-left">
                                 <span style="width:30%">Sex</span>
                                 <span class="pet-eligibility-dot">:</span>
                                 <span style="width:68%;color:white;" class="pet-eligibility  text-left">
                                    {{pet.gender.name}}</span>
                              </p>
                              <p *ngIf="pet.dateOfBirth && pet.dateOfBirth != ''"
                                 class="pet-eligibility-text text-left">
                                 <span style="width:30%">Age</span>
                                 <span class="pet-eligibility-dot">:</span>
                                 <span style="width:68%;color:white;" class="pet-eligibility  text-left">
                                    {{getAgeInWords(pet.dateOfBirth)}}</span>
                              </p>
                              <p *ngIf="pet.weight" class="pet-eligibility-text text-left">
                                 <span style="width:30%">Weight</span>
                                 <span class="pet-eligibility-dot">:</span>
                                 <span style="width:68%;color:white;" class="pet-eligibility  text-left"> {{pet.weight}}
                                    lbs</span>
                              </p>
                           </div>
                        </div>
                     </div>
                     <div class="card " style="margin-top: 10px;border-radius: 20px;min-height:320px"
                        *ngIf="!pet.selected" (click)="onMembershipPetChange(pet)">
                        <div class="card-body" style="text-align: center;cursor: pointer;padding: 0px !important">
                           <img
                              *ngIf="!pet.document || !pet.document.attachments || pet.document.attachments.length == 0"
                              src="assets/images/dog-placeholder.png"
                              class="pet-image mt-10">
                           <img
                              *ngIf="pet.document && pet.document.attachments && pet.document.attachments.length > 0 && pet.document.attachments[0].url"
                              src="{{pet.document.attachments[0].url}}" class="pet-image ">
                           <div style=" padding: 10px;">
                              <h5 class="card-title " style="font-size: 18px;">{{pet.name}}</h5>
                              <p *ngIf="pet.breed" class="pet-eligibility-text text-left">
                                 <span style="width:30%">Breed</span>
                                 <span class="pet-eligibility-dot">:</span>
                                 <span style="width:68%" class="pet-eligibility  text-left"> {{pet.breed.name}}</span>
                              </p>
                              <p *ngIf="pet.gender" class="pet-eligibility-text text-left">
                                 <span style="width:30%">Sex</span>
                                 <span class="pet-eligibility-dot">:</span>
                                 <span style="width:68%" class="pet-eligibility  text-left"> {{pet.gender.name}}</span>
                              </p>
                              <p *ngIf="pet.dateOfBirth && pet.dateOfBirth != ''"
                                 class="pet-eligibility-text text-left">
                                 <span style="width:30%">Age</span>
                                 <span class="pet-eligibility-dot">:</span>
                                 <span style="width:68%" class="pet-eligibility  text-left">
                                    {{getAgeInWords(pet.dateOfBirth)}}</span>
                              </p>
                              <p *ngIf="pet.weight" class="pet-eligibility-text text-left">
                                 <span style="width:30%">Weight</span>
                                 <span class="pet-eligibility-dot">:</span>
                                 <span style="width:68%" class="pet-eligibility  text-left"> {{pet.weight}} lbs</span>
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="clearfix" *ngIf="pageShowType == 'showpets' && selectedPurchaseType != 'service'">
               <button class="btn btn-custom float-right next" [disabled]="isLoading || buttonDisabled"
                  (click)="validateUserAddress('save');nextStep($event, 'membership-confirm')">Purchase <img
                     src="assets/images/next.png" width="20px" style="margin-left: 10px;" /></button>
               <button class="btn btn-custom float-left" [disabled]="isLoading || buttonDisabled"
                  (click)="goBack('petInfo')">Back</button>
            </div>
            <div class="form-group mb-0" *ngIf="pageShowType == 'addpet'">
               <form #addPetForm="ngForm">
                  <h3 for="addPet" class="font-weight-bold mb-0">Tell us about your Pet?</h3>
                  <div id="addPet">
                     <div class="form-group mb-0">
                        <label for="petName" class="font-weight-bold">Pet Name <span style="color: red;">*</span>
                        </label>
                        <div id="petName">
                           <mat-form-field appearance="outline">
                              <mat-label>Pet Name</mat-label>
                              <input matInput placeholder="Pet Name" [formControl]="petNameCtrl"
                                 (keyup)="onNameChange($event, petNameCtrl)" required>
                              <mat-error *ngIf="petNameCtrl.invalid">{{getErrorMessage(petNameCtrl, 'Pet Name',
                                 'required')}}</mat-error>
                           </mat-form-field>
                        </div>
                     </div>
                     <div class="form-group">
                        <label for="petType" class="font-weight-bold">Pet Type <span
                              style="color: red;">*</span></label>
                        <div id="petType">
                           <mat-button-toggle-group name="newPetType" aria-label="Pet Types" [(ngModel)]="newPetID"
                              [ngModelOptions]="{standalone: true}" (change)="onNewPetTypeChange($event)" disabled>
                              <mat-button-toggle *ngFor="let petType of petTypes" [value]="petType.id">
                                 {{petType.name ? petType.name : petType.name}}</mat-button-toggle>
                           </mat-button-toggle-group>
                        </div>
                     </div>
                     <div class="form-group">
                        <label for="petSex" class="font-weight-bold">Sex <span *ngIf="isMandatory('gender','add')"
                              style="color: red;">*</span></label>
                        <div id="petSex">
                           <mat-button-toggle-group name="petSex" aria-label="Pet Sexs" [(ngModel)]="selectedPetGender"
                              [ngModelOptions]="{standalone: true}" [ngModelOptions]="{standalone: true}">
                              <mat-button-toggle *ngFor="let petGender of petGenders" [value]="petGender.id">
                                 {{petGender.name ? petGender.name : petGender.name}}</mat-button-toggle>
                           </mat-button-toggle-group>
                        </div>
                     </div>
                     <div class="form-group mb-0">
                        <label for="petBread" class="font-weight-bold">Breed <span style="color: red;">*</span> </label>
                        <div id="petBread">
                           <mat-form-field appearance="outline">
                              <mat-select placeholder="Select Breed" [(ngModel)]="selectedPetBread" name="breed"
                                 (selectionChange)="onPetBreadChange($event)">
                                 <mat-option (click)="$event.stopPropagation()">
                                    <input matInput placeholder="Search breed..." [(ngModel)]="breedSearchTerm"
                                       (ngModelChange)="filterBreeds()" name="dummySearch" autocomplete="off"
                                       class="breed-search-input" (click)="$event.stopPropagation()"
                                       (keydown)="$event.stopPropagation()" />
                                 </mat-option>
                                 <mat-option *ngFor="let breed of filteredBreeds" [value]="breed.id">
                                    {{ breed.name }}
                                 </mat-option>
                                 <mat-option class="read-more-option"
                                    (click)="readMore($event);$event.stopPropagation()" *ngIf="moreBreeds">
                                    <button mat-button (click)="readMore($event); $event.stopPropagation()"
                                       style="border:none">Read more</button>
                                 </mat-option>
                              </mat-select>
                           </mat-form-field>
                           <!-- <mat-form-field appearance="outline">
                              <mat-label>Selected Breed</mat-label>
                              <mat-select name="petBread" (selectionChange)="onPetBreadChange($event)"
                                 [(ngModel)]="selectedPetBread" [ngModelOptions]="{standalone: true}">
                                 <mat-option *ngFor="let petBread of petBreeds" [value]="petBread.id">
                                    {{petBread.name ? petBread.name : petBread.name}}
                                 </mat-option>
                              </mat-select>
                           </mat-form-field> -->
                        </div>
                     </div>
                     <div class="form-group mb-0">
                        <label for="petWeight" class="font-weight-bold">Weight <span *ngIf="isMandatory('weight','add')"
                              style="color: red;">*</span></label>
                        <div id="petWeight">
                           <mat-form-field appearance="outline">
                              <mat-label>Weight</mat-label>
                              <input matInput placeholder="Ex. 1.2" min="0" [(ngModel)]="petWeight"
                                 [ngModelOptions]="{standalone: true}" mask="separator.2">
                              <span matSuffix>lb</span>
                           </mat-form-field>
                        </div>
                     </div>
                     <div class="form-group mb-0">
                        <label for="petWeight" class="font-weight-bold">Pet Color <span
                              *ngIf="isMandatory('color','add')" style="color: red;">*</span></label>
                        <div id="petWeight">
                           <mat-form-field appearance="outline">
                              <mat-label>Color</mat-label>
                              <input matInput placeholder="Ex. White" min="0" [(ngModel)]="petColor"
                                 [ngModelOptions]="{standalone: true}">
                           </mat-form-field>
                        </div>
                     </div>
                     <div class="form-group mb-0">
                        <label for="petVeterinarian" class="font-weight-bold"
                           style="width: 450px;display: flex;justify-content: space-between;">
                           <span>Veterinarian <span *ngIf="isMandatory('vet','add')" style="color: red;">*</span></span>
                           <button (click)="showAddVet()" style="cursor: pointer;" class="btn btn-custom">Add
                              Veterinarian</button>
                        </label>
                        <div id="petVeterinarian">
                           <mat-form-field appearance="outline" style="width: 450px;">
                              <mat-label>Search for veterinarian</mat-label>
                              <input type="text" #vetInput placeholder="Pick one" aria-label="Number" matInput
                                 [formControl]="myControl" [matAutocomplete]="auto" (input)="filterVet()"
                                 (focus)="filterVet()">
                              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                 (optionSelected)='selectedVet($event)' [displayWith]="displayProperty">
                                 <ng-container>
                                    <mat-option *ngFor="let option of filteredVet" [value]="option">
                                       {{ option.name }}
                                    </mat-option>
                                 </ng-container>
                              </mat-autocomplete>
                           </mat-form-field>
                        </div>
                     </div>
                     <div class="form-group mb-0">
                        <label for="birthday" class="font-weight-bold">Birthday <span
                              *ngIf="isMandatory('birthday','add')" style="color: red;">*</span></label>
                        <div id="birthday" style="width: 250px;">
                           <!-- <input type="text" class="form-control" #dp="bsDatepicker" bsDatepicker placement="top"
                              [bsValue]="bsValue" (bsValueChange)="petOldChange($event)" [maxDate]="today"
                              [bsConfig]="{ showWeekNumbers: false }"> -->
                           <mat-form-field appearance="outline">
                              <mat-label>Choose pet birthday</mat-label>
                              <input matInput [matDatepicker]="picker1" readonly placeholder="Choose pet birthday"
                                 [ngModelOptions]="{standalone: true}" [(ngModel)]="bsValue"
                                 (ngModelChange)="petOldChange($event)" [max]="today">
                              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                              <mat-datepicker #picker1 startView="multi-year"></mat-datepicker>
                           </mat-form-field>
                        </div>
                        <h5 class="font-weight-bold ml-2">{{petOldStr}}</h5>
                     </div>
                  </div>
               </form>
               <div class="clearfix" *ngIf="pageShowType == 'addpet'">
                  <button class="btn btn-custom float-right" [disabled]="isLoading || buttonDisabled"
                     (click)="nextStep($event, 'addpet')">{{userPets.length >= convertInt(selectedPetNum)-1 ? 'Next' :
                     'Add Pet'}}</button>
                  <button class="btn btn-custom float-left" [disabled]="isLoading || buttonDisabled"
                     (click)="goBack('petInfo');setPetType();">Back</button>
               </div>
            </div>
            <div class="form-group mb-0" *ngIf="pageShowType == 'editPets'">
               <form #addPetForm="ngForm">
                  <h3 for="addPet" class="font-weight-bold mb-0">Tell us about your Pet?</h3>
                  <div id="addPet">
                     <div class="form-group mb-0">
                        <label for="petName" class="font-weight-bold">Pet Name</label>
                        <div id="petName">
                           <mat-form-field appearance="outline">
                              <mat-label>Pet Name</mat-label>
                              <input matInput placeholder="Pet Name" [formControl]="petNameCtrl"
                                 (keyup)="onNameChange($event, petNameCtrl)" required>
                              <mat-error *ngIf="petNameCtrl.invalid">{{getErrorMessage(petNameCtrl, 'Pet Name',
                                 'required')}}</mat-error>
                           </mat-form-field>
                        </div>
                     </div>
                     <div class="form-group">
                        <label for="petType" class="font-weight-bold">Pet Type <span
                              style="color: red;">*</span></label>
                        <div id="petType">
                           <mat-button-toggle-group name="newPetType" aria-label="Pet Types" [(ngModel)]="newPetID"
                              [ngModelOptions]="{standalone: true}" (change)="onNewPetTypeChange($event)" disabled>
                              <mat-button-toggle *ngFor="let petType of petTypes" [value]="petType.id">
                                 {{petType.name ? petType.name : petType.name}}</mat-button-toggle>
                           </mat-button-toggle-group>
                        </div>
                     </div>
                     <div class="form-group">
                        <label for="petSex" class="font-weight-bold">Sex <span *ngIf="isMandatory('gender','edit')"
                              style="color: red;">*</span> </label>
                        <div id="petSex">
                           <mat-button-toggle-group name="petSex" aria-label="Pet Sexs" [(ngModel)]="selectedPetGender"
                              [ngModelOptions]="{standalone: true}" [ngModelOptions]="{standalone: true}">
                              <mat-button-toggle *ngFor="let petGender of petGenders" [value]="petGender.id">
                                 {{petGender.name ? petGender.name : petGender.name}}</mat-button-toggle>
                           </mat-button-toggle-group>
                        </div>
                     </div>
                     <div class="form-group mb-0">
                        <label for="petBread" class="font-weight-bold">Breed <span style="color: red;">*</span></label>
                        <div id="petBread">
                           <mat-form-field appearance="outline">
                              <mat-select placeholder="Select Breed" [(ngModel)]="selectedPetBread" name="breed"
                                 (selectionChange)="onPetBreadChange($event)">
                                 <mat-option (click)="$event.stopPropagation()">
                                    <input matInput placeholder="Search breed..." [(ngModel)]="breedSearchTerm"
                                       (ngModelChange)="filterBreeds()" name="dummySearch" autocomplete="off"
                                       class="breed-search-input" (click)="$event.stopPropagation()"
                                       (keydown)="$event.stopPropagation()" />
                                 </mat-option>
                                 <mat-option *ngFor="let breed of filteredBreeds" [value]="breed.id">
                                    {{ breed.name }}
                                 </mat-option>
                                 <mat-option class="read-more-option"
                                    (click)="readMore($event);$event.stopPropagation()" *ngIf="moreBreeds">
                                    <button mat-button (click)="readMore($event); $event.stopPropagation()"
                                       style="border:none">Read more</button>
                                 </mat-option>
                              </mat-select>
                           </mat-form-field>
                           <!-- <mat-form-field appearance="outline">
                              <mat-label>Selected Breed</mat-label>
                              <mat-select name="petBread" (selectionChange)="onPetBreadChange($event)"
                                 [(ngModel)]="selectedPetBread" [ngModelOptions]="{standalone: true}">
                                 <mat-option *ngFor="let petBread of petBreeds" [value]="petBread.id">
                                    {{petBread.name ? petBread.name : petBread.name}}
                                 </mat-option>
                              </mat-select>
                           </mat-form-field> -->
                        </div>
                     </div>
                     <div class="form-group mb-0">
                        <label for="petWeight" class="font-weight-bold">Weight <span
                              *ngIf="isMandatory('weight','edit')" style="color: red;">*</span> </label>
                        <div id="petWeight">
                           <mat-form-field appearance="outline">
                              <mat-label>Weight</mat-label>
                              <input matInput placeholder="Ex. 1.2" min="0" [(ngModel)]="petWeight"
                                 [ngModelOptions]="{standalone: true}" mask="separator.2">
                              <span matSuffix>lb</span>
                           </mat-form-field>
                        </div>
                     </div>
                     <div class="form-group mb-0">
                        <label for="petWeight" class="font-weight-bold">Pet Color <span
                              *ngIf="isMandatory('color','edit')" style="color: red;">*</span></label>
                        <div id="petWeight">
                           <mat-form-field appearance="outline">
                              <mat-label>Color</mat-label>
                              <input matInput placeholder="Ex. White" min="0" [(ngModel)]="petColor"
                                 [ngModelOptions]="{standalone: true}">
                           </mat-form-field>
                        </div>
                     </div>
                     <div class="form-group mb-0">
                        <label for="petVeterinarian" class="font-weight-bold"
                           style="width: 450px;display: flex;justify-content: space-between;">
                           <span>Veterinarian <span *ngIf="isMandatory('vet','edit')"
                                 style="color: red;">*</span></span>
                           <button (click)="showAddVet()" style="cursor: pointer;" class="btn btn-custom">Add
                              Veterinarian</button>
                        </label>
                        <div id="petVeterinarian">
                           <mat-form-field appearance="outline" style="width: 450px;">
                              <mat-label>Search for veterinarian</mat-label>
                              <input type="text" #vetInput placeholder="Pick one" aria-label="Number" matInput
                                 [formControl]="myControl" [matAutocomplete]="auto" (input)="filterVet()"
                                 (focus)="filterVet()">
                              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                 (optionSelected)='selectedVet($event)' [displayWith]="displayProperty">
                                 <ng-container>
                                    <mat-option *ngFor="let option of filteredVet" [value]="option">
                                       {{ option.name }}
                                    </mat-option>
                                 </ng-container>
                              </mat-autocomplete>
                           </mat-form-field>
                        </div>
                     </div>
                     <div class="form-group mb-0">
                        <label for="birthday" class="font-weight-bold">Birthday <span
                              *ngIf="isMandatory('birthday','edit')" style="color: red;">*</span></label>
                        <div id="birthday" style="width: 250px;">
                           <!-- <input type="text" class="form-control" #dp="bsDatepicker" bsDatepicker placement="top"
                              [bsValue]="bsValue" (bsValueChange)="petOldChange($event)" [maxDate]="today"
                              [bsConfig]="{ showWeekNumbers: false }"> -->
                           <mat-form-field appearance="outline">
                              <mat-label>Choose pet birthday</mat-label>
                              <input matInput [matDatepicker]="picker2" readonly placeholder="Choose pet birthday"
                                 [ngModelOptions]="{standalone: true}" [(ngModel)]="bsValue"
                                 (ngModelChange)="petOldChange($event)" [max]="today">
                              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                              <mat-datepicker #picker2 startView="multi-year"></mat-datepicker>
                           </mat-form-field>
                        </div>
                        <h5 class="font-weight-bold ml-2">{{petOldStr}}</h5>
                     </div>
                  </div>
               </form>
               <div class="clearfix">
                  <button class="btn btn-custom float-right" [disabled]="isLoading || buttonDisabled"
                     (click)="nextStep($event, 'editPet')">{{userPets.length >= convertInt(selectedPetNum)-1 ? 'Next' :
                     'Add Pet'}}</button>
                  <button class="btn btn-custom float-left" [disabled]="isLoading || buttonDisabled"
                     (click)="goBack('petInfo');setPetType();">Back</button>
               </div>
            </div>
         </mat-step>

         <mat-step *ngIf="selectedPurchaseType == 'service'">
            <ng-template matStepLabel>Confirm</ng-template>
            <!-- <button (click)="show()"> clc</button> -->
            <app-dialog-pop-up [agreements]="agreements" [qrCodeData]="qrCodeData"
               [petOwnersAgreements]="petOwnersAgreements" [agreementPassCheck]="agreementPassCheck"
               [immunizationsForPets]="immunizationsForPets" [immunizationPassCheck]="immunizationPassCheck"
               [showAgreementForSign]="showAgreement" [showImmunization]="showImmunization"
               (submitForImmunization)="updateImmunization($event)" (submitted)="updateAgreementSignedStatus()"
               (enableReq)="enableReq($event)" (questionAnsweredEvent)="qAPassCheckevent($event)"
               #ForceShow></app-dialog-pop-up>

            <div class="form-group" *ngIf="!appoint_res" style="padding: 10px;
            padding-left: 25px;
            border: 1px dashed;">
               <div *ngFor="let app of appponitmentSummary">
                  <p style="font-weight: 600;">{{app.pet.name}}</p>
                  <div *ngFor="let res of app.reservationTypes">
                     <p>{{res.name}} : {{formatTimestamp(res)}} </p>
                  </div>
               </div>
            </div>
            <div *ngIf="appoint_res">

               <div *ngIf="appointmentCreated && appoint_res['status'] == 'PENDING' ">
                  <p style="color: red;text-align: center;">Your appointment has not yet been approved</p>
                  <p style="color:red;text-align: center;">We will review your request as soon as possible</p>
               </div>

               <div class="form-group">
                  <h2 class="font-weight-bold mb-0 font-red" *ngIf="appoint_res['status']=='DRAFT'">
                     {{resultStatusDesc}}
                  </h2>

                  <!-- <h3 class="font-weight-bold mb-0" *ngIf="appoint_res['status']!='DRAFT'">
                     {{resultStatusDesc}}
                  </h3> -->

                  <div class="card-text" *ngIf="appoint_res['status']!='DRAFT'">
                     <b>Invoice</b> #: {{appoint_res['appointmentKey']}}
                  </div>
               </div>

               <div class="form-group">
                  <!-- <div class="card-text">{{resultStatusDesc}}</div> -->
               </div>

               <div class="form-group" *ngIf="appoint_res['status'] == 'CONFIRMED'">
                  <div class="card-text">We can't wait to see {{pet_names}} at {{start_time_str}} <span
                        *ngIf="showEndTimeInSummary">To {{end_time_str}} </span> at
                     {{displayAddress}}</div>
               </div>

               <!-- <ng-container *ngIf="forceDepositForAppAndWeb && depositRequired">
                  <div style="display: flex;justify-content: center;margin-bottom: 15px;">
                     <button class="btn btn-custom" (click)="payDeposit()">{{ 'Pay Deposit $ ' + depositAmount }}</button>
                  </div>
               </ng-container> -->

               <ng-container *ngIf="depositRequired">
                  <!-- <div style="margin-top: 15px;"></div>

                  <p>Saved Cards</p>

                  <hr />

                  <ng-container *ngIf="showSavedCards">
                     <table mat-table [dataSource]="appService.savedCards" class="mat-elevation-z8" style="width:100%">
                        <ng-container matColumnDef="details">
                           <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Details </th>
                           <td mat-cell *matCellDef="let element">
                              <div style="display: flex;gap: 113px;">
                                 <mat-radio-button [value]="element"></mat-radio-button>
                                 <mat-icon style="margin-right: 10px;">credit_card</mat-icon>
                                 <div style="display: flex;align-items: center;font-weight: 550;">**** **** **** {{element.lastFourDigit.substring(element.lastFourDigit.length-4)}}</div>
                              </div>
                           </td>
                       </ng-container>>

                        <tr mat-header-row *matHeaderRowDef="savedCardColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: savedCardColumns;"></tr>
                    </table>
                  </ng-container>

                  <div style="margin-bottom: 15px;"></div> -->

                  <div style="background-color: #eee;
                                    text-align: center;
                                    border-radius: 5px;
                                    padding: 1rem;">

                     <p style="font-size: 1.5rem;
                                       line-height: 3;">{{ 'Deposit $' + appoint_res.depositAmount +' Required'}}</p>

                     <table mat-table [dataSource]="activeCards" class="mat-elevation-z8"
                        style="width:100%; margin-bottom: 10px; margin-top: 10px;"
                        *ngIf="activeCards && activeCards.length > 0">
                        <ng-container matColumnDef="details">
                           <th mat-header-cell *matHeaderCellDef> Save card on file </th>
                           <td mat-cell *matCellDef="let element">
                              <div class="cod_inner">
                                 <!-- <mat-radio-button [value]="element" (change)="handleCardChange($event)"
                                    style="margin-left: 0px !important;">
                                 </mat-radio-button> -->
                                 <div style="display: flex; align-items: center; font-weight: 550;">
                                    <mat-icon style="margin-right: 10px;">credit_card</mat-icon>
                                    **** **** **** {{ element.lastFourDigit.substring(element.lastFourDigit.length - 4)
                                    }}
                                 </div>
                              </div>
                           </td>
                        </ng-container>
                        <ng-container matColumnDef="cvvDetails">
                           <th mat-header-cell *matHeaderCellDef> CVV </th>
                           <td mat-cell *matCellDef="let element">
                              <div style="display: flex; width: fit-content;">
                                 <input *ngIf="element.ccvRequired" type="text" class="form-control" placeholder="CVV"
                                    [(ngModel)]="element.cvvValue" style="width: 100px; margin: auto;"
                                    (keypress)="validateNumberInput($event)" maxlength="4" />
                                 <span style="color: red; font-size: 16px;">*</span>
                              </div>
                           </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                           <th mat-header-cell *matHeaderCellDef style="text-align:center"> Action </th>
                           <td mat-cell *matCellDef="let element">
                              <button class="btn btn-custom" [disabled]="disablePayDepositBtn"
                                 (click)="depositPaySavedCard(element)" style="margin-right: 10px;"
                                 *ngIf="showSavedCard">
                                 Proceed with this card
                              </button>
                           </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="cardColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: cardColumns;"></tr>
                     </table>
                     <re-captcha *ngIf="showCaptchaForCard" siteKey="6LdMENsZAAAAAMqFM9PKysYwkmEO778o2j_iS9Qh"
                        (resolved)="onCardCaptchaResolved($event)">
                     </re-captcha>
                     <p *ngIf="cardCaptchaError" style="color: red;">{{ cardCaptchaError }}</p>
                     <button class="btn btn-custom" [disabled]="disablePayDepositBtn" (click)="depositPayNewCard()"
                        style="margin-right: 10px;">
                        Proceed With New Card
                     </button>
                     <!-- <button class="btn btn-custom" (click)="getSavedCards()">{{ 'Pay Deposit $' + appoint_res.depositAmount }}</button>                      -->
                  </div>

                  <div style="margin-bottom: 15px;"></div>
               </ng-container>
            </div>
            <!-- <button (click)="get()">click</button> -->
            <div class="clearfix" *ngIf="!appointmentCreated">
               <button class="btn btn-custom float-right" matTooltip="Some of the informations are missing"
                  [matTooltipDisabled]="!(!enableReqAppiontment || !agreementPassCheck || !immunizationPassCheck || qAPassCheck)"
                  [disabled]="!enableReqAppiontment || !agreementPassCheck || !immunizationPassCheck || qAPassCheck"
                  (click)="proceedAppointment()">Confirm</button>
               <button class="btn btn-custom float-left" [disabled]="buffer" (click)="goBack('petDetail')">Back</button>
            </div>


            <div class="clearfix" *ngIf="appointmentCreated">
               <button class="btn btn-custom float-right" (click)="stepper.reset();reload()">Request New
                  Appointment</button>
            </div>
         </mat-step>

         <mat-step *ngIf="selectedPurchaseType != 'service'">
            <ng-template matStepLabel>Purchase</ng-template>
            <ng-container
               *ngIf="showAgreement && ((selectedMembership && selectedPurchaseType == 'membership') || (selectedSession && selectedPurchaseType == 'training'))">
               <h4 style="font-size:22px;margin-bottom: 0px !important;">Agreement Required</h4>
               <span style="color:red"> <br> Agreement must be signed before purchasing a
                  <span *ngIf="selectedMembership && selectedPurchaseType == 'membership'"> membership </span>
                  <span *ngIf="selectedSession && selectedPurchaseType == 'training'"> training session </span>
               </span>
               <table mat-table [dataSource]="agreementsRequired" class="mat-elevation-z8"
                  style="width:100%;margin-bottom: 20px;">
                  <ng-container matColumnDef="name">
                     <th mat-header-cell *matHeaderCellDef> Name </th>
                     <td mat-cell *matCellDef="let element"
                        [ngClass]="{'force-agreement-color' : (element.forceWhileMembershipPurchase && element.status != 'SIGNED')}">
                        {{element.name}} ({{element.agreementFor}}) </td>
                  </ng-container>

                  <ng-container matColumnDef="signed date">
                     <th mat-header-cell *matHeaderCellDef style="width:20%;"> Signed Date </th>
                     <td mat-cell *matCellDef="let element"
                        [ngClass]="{'force-agreement-color' : (element.forceWhileMembershipPurchase && element.status != 'SIGNED')}">
                        <ng-container *ngIf="element.signedDate">
                           <span>{{ formatDate(element.signedDate, 'MM/dd/yyyy')}}</span>
                           <span style="margin-left:5px;">{{ formatDate(element.signatureTime, 'hh:mm a')}}</span>
                        </ng-container>
                     </td>
                  </ng-container>

                  <ng-container matColumnDef="expiration date">
                     <th mat-header-cell *matHeaderCellDef style="width:20%;"> Expiration Date </th>
                     <td mat-cell *matCellDef="let element"
                        [ngClass]="{'force-agreement-color' : (element.forceWhileMembershipPurchase && element.status != 'SIGNED')}">
                        <ng-container *ngIf="element.expirationDate">
                           <span>{{ formatDate(element.expirationDate, 'MM/dd/yyyy hh:mm a')}}</span>
                        </ng-container>
                     </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                     <th mat-header-cell *matHeaderCellDef> Status </th>
                     <td mat-cell *matCellDef="let element"
                        [ngClass]="{'force-agreement-color' : (element.forceWhileMembershipPurchase && element.status != 'SIGNED')}">
                        {{element.status}} </td>
                  </ng-container>


                  <ng-container matColumnDef="action">
                     <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Action <br> (click below to
                        sign)</th>
                     <td mat-cell *matCellDef="let element" style="text-align: center;"
                        [ngClass]="{'force-agreement-color' : (element.forceWhileMembershipPurchase && element.status != 'SIGNED')}">
                        <img src="assets/images/signature.svg"
                           style="height: 30px;width:30px;margin-left:5px;cursor:pointer"
                           (click)="openAgreement(element)" />
                     </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsForAgreements"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsForAgreements;"></tr>
               </table>
            </ng-container>
            <ng-container
               *ngIf="(selectedMembership && selectedMembership.immTypes && selectedMembership.immTypes.length > 0 && selectedMembership.requireVaccineInfo  && selectedPurchaseType == 'membership' && immunizationsForPets && immunizationsForPets.length > 0 && hasImmunizationsToShow()) || (selectedSession && selectedSession.groupService && selectedSession.groupService.immTypes && selectedSession.groupService.immTypes.length > 0  && selectedPurchaseType == 'training' && immunizationsForPets && immunizationsForPets.length > 0 && hasImmunizationsToShow())">
               <h4 style="font-size:22px;margin-bottom: 0px !important;">Immunization Required</h4>
               <span style="color:red;"> <br> Immunization must be uploaded before purchasing a
                  <span *ngIf="selectedMembership && selectedPurchaseType == 'membership'"> membership </span>
                  <span *ngIf="selectedSession && selectedPurchaseType == 'training'"> training session </span>
               </span>
               <ng-container *ngFor="let immunization of immunizationsForPets">
                  <ng-container *ngIf="showImmunizations(immunization.immunizations)">
                     <h3 style="margin-bottom: 0px;font-weight: 600;font-size: 22px;" class="immunization-petname">
                        {{ immunization.name }}
                     </h3>

                     <hr style="margin-bottom: 10px;margin-top: 10px;" />

                     <table mat-table [dataSource]="immunization.immunizations" class="mat-elevation-z8"
                        style="width:100%">
                        <ng-container matColumnDef="name">
                           <th mat-header-cell *matHeaderCellDef> Name </th>
                           <td mat-cell *matCellDef="let element"> {{element.petImmunizationTypeName}} </td>
                        </ng-container>

                        <ng-container matColumnDef="expiry date">
                           <th mat-header-cell *matHeaderCellDef style="width:20%;"> Expiry Date </th>
                           <td mat-cell *matCellDef="let element">
                              <ng-container *ngIf="element.endDate">
                                 <span>{{ formatDate(element.endDate, 'MM/dd/yyyy')}}</span>
                              </ng-container>
                           </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                           <th mat-header-cell *matHeaderCellDef style="width:20%;"> Status </th>
                           <td mat-cell *matCellDef="let element"> {{element.status}} </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                           <th mat-header-cell *matHeaderCellDef style="text-align: right;"> Action </th>
                           <td mat-cell *matCellDef="let element" style="text-align: right;">
                              <button mat-button style="background-color: #41A049;color:white"
                                 (click)="showAddImmunizationDialog(immunization)"> Add</button>
                           </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsForImmunizations"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsForImmunizations;"></tr>
                     </table>

                     <div style="margin-bottom:20px "></div>
                  </ng-container>
               </ng-container>
            </ng-container>
            <ng-container *ngIf="selectedMembership  && selectedPurchaseType == 'membership'">
               <div *ngIf="selectedMembership.displayDateWhilePurchase" style="text-align: center;">
                  <mat-form-field appearance="outline">
                     <mat-label>Membership Start Date</mat-label>
                     <input matInput [matDatepicker]="picker" placeholder="Membership Start Date"
                        [(ngModel)]="selectedMembership.startDate" (ngModelChange)="membershipStartDateChange($event)"
                        [min]="minDate" required>
                     <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                     <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
               </div>
               <div *ngIf="!selectedMembership.displayDateWhilePurchase" style="text-align: center;">
                  <p>Membership Start Date: {{getMembershipStartDate()}}</p>
               </div>
               <div *ngIf="selectedMembership.allowAutoRenewal" style="text-align: center;">
                  <div *ngIf="selectedMembership.showAutoRenewalOption">
                     <mat-radio-group name="membershipPurchaseType" [(ngModel)]="selectedMembership.autoRenewal"
                        [ngModelOptions]="{standalone: true}">
                        <mat-radio-button value="false">Purchase Once</mat-radio-button>
                        <mat-radio-button value="true">Setup Auto Renew</mat-radio-button>
                     </mat-radio-group>
                  </div>
                  <div *ngIf="!selectedMembership.showAutoRenewalOption">
                     <p style="color: red;">PLEASE NOTE : This is a recurring subscription</p>
                  </div>
               </div>
               <div *ngIf="selectedMembership.allowAutoRenewal" style="text-align: center;">
                  <h3 style="margin-bottom: 0px;">Setup Auto-Renew for {{selectedMembership.name}}</h3>
                  <p>In order to set up recurring payments for this purchase the client needs to have a saved card on
                     file</p>
               </div>
            </ng-container>
            <ng-container *ngIf="selectedMembership && selectedPurchaseType == 'membership'">
               <div style="margin: auto;margin-bottom: 10px !important;width: 55%;border:1px dashed;padding: 15px;">
                  <div>
                     <span>
                        <div
                           style="display: flex; justify-content: space-between;margin: 0px -15px;padding: 0px 15px;padding-bottom: 5px;border-bottom: 1px dashed grey;margin-bottom: 10px;">
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">
                                 Item Details
                              </p>
                           </div>
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">Amount</p>
                           </div>
                        </div>
                     </span>
                  </div>
                  <div style="display: flex; justify-content: space-between;">
                     <div style="display: flex; flex-direction: column;">
                        <p>
                           {{selectedMembership.name}} - {{selectedMembership.petNames}}
                           <span (click)="showInvoiceDescription()"
                              *ngIf="selectedMembership.services && selectedMembership.services.length > 0">></span>
                        </p>
                        <span *ngIf="showRules">
                           <span *ngIf="selectedMembership.services && selectedMembership.services.length > 0">
                              <span *ngFor="let data of selectedMembership.serviceRules;index as i">
                                 <span *ngFor="let service of data.rule">
                                    {{service.name}} - {{service.quantity}}<br>
                                 </span>
                                 <span *ngIf="i != ( selectedMembership.serviceRules.length - 1)">
                                    <h5 style="margin:5px 0px !important">(OR)</h5>
                                 </span>
                              </span>
                           </span>
                        </span>
                     </div>
                     <div style="display: flex; flex-direction: column;">
                        <p style="font-weight: 600;">
                           ${{selectedMembership.reservationServices.service.priceTiers[0].amount.toFixed(2)}}</p>
                        <p style="margin: 0px;"
                           *ngIf="selectedMembership.reservationServices.service.taxPercentage && selectedMembership.reservationServices.service.taxPercentage > 0">
                           Tax: {{selectedMembership.reservationServices.service.taxPercentage || 0 }} %</p>
                     </div>
                  </div>
                  <hr *ngIf="hasvalidCoupon && couponDetails">
                  <div style="display: flex; justify-content: space-between;align-items: baseline;"
                     *ngIf="hasvalidCoupon && couponDetails">
                     <div style="display: flex; flex-direction: column;">
                        <p>
                           {{couponDetails.name}} - {{couponDetails.code}} ({{getCouponDiscountValue()}})
                        </p>
                     </div>
                     <div style="display: flex; flex-direction: column;">
                        <p style="margin-right:-15px;">- $ {{getCouponDiscount()}}<mat-icon
                              style="color: red;margin: 5px;cursor: pointer;vertical-align: middle;"
                              (click)="removeCoupon()">delete</mat-icon></p>
                     </div>
                  </div>
                  <hr>
                  <div style="text-align: right;" *ngIf="!hasCoupon && !hasvalidCoupon">
                     <button style="cursor: pointer;" class="btn btn-custom" (click)="addCoupon()">Add Coupon</button>
                  </div>
                  <div style="display: flex; justify-content: space-between;">
                     <div *ngIf="hasCoupon && !hasvalidCoupon">
                        <mat-form-field appearance="outline">
                           <mat-label>Coupon Code</mat-label>
                           <input matInput [(ngModel)]="couponCode" style="margin-top: 10px;"
                              placeholder="Enter Coupon Code">
                        </mat-form-field>
                        <mat-icon style="color:green;margin: 5px;cursor: pointer;"
                           (click)="validateCoupon()">check</mat-icon>
                        <mat-icon style="color: red;margin: 5px;cursor: pointer;"
                           (click)="removeCoupon()">close</mat-icon>
                     </div>
                  </div>
                  <hr>
                  <div>
                     <span>
                        <div
                           style="display: flex; justify-content: space-between;margin: 0px -15px;padding: 0px 15px;padding-top: 5px;border-top: 1px dashed grey;margin-top: 10px;">
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">
                                 Total:
                              </p>
                           </div>
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">${{getPaymentTotal()}}</p>
                           </div>
                        </div>
                     </span>
                  </div>
               </div>
            </ng-container>
            <ng-container *ngIf="selectedMembership  && selectedPurchaseType == 'membership'">
               <div style="background-color: #eee;text-align: center;border-radius: 5px;padding: 1rem;">
                  <p style="font-size: 1.5rem;line-height: 3;" *ngIf="selectedMembership">{{ 'Payment of $' +
                     getPaymentTotal() +' Required'}}</p>
                  <table mat-table [dataSource]="activeCards" class="mat-elevation-z8"
                     style="width:100%; margin-bottom: 10px; margin-top: 10px;"
                     *ngIf="activeCards && activeCards.length > 0">
                     <ng-container matColumnDef="details">
                        <th mat-header-cell *matHeaderCellDef> Save card on file </th>
                        <td mat-cell *matCellDef="let element">
                           <div class="cod_inner">
                              <!-- <mat-radio-button [value]="element" (change)="handleCardChange($event)"
                                    style="margin-left: 0px !important;">
                                 </mat-radio-button> -->
                              <div style="display: flex; align-items: center; font-weight: 550;">
                                 <mat-icon style="margin-right: 10px;">credit_card</mat-icon>
                                 **** **** **** {{ element.lastFourDigit.substring(element.lastFourDigit.length - 4) }}
                              </div>
                           </div>
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="cvvDetails">
                        <th mat-header-cell *matHeaderCellDef> CVV </th>
                        <td mat-cell *matCellDef="let element">
                           <div style="display: flex; width: fit-content;">
                              <input *ngIf="element.ccvRequired" type="text" class="form-control" placeholder="CVV"
                                 [(ngModel)]="element.cvvValue" style="width: 100px; margin: auto;"
                                 (keypress)="validateNumberInput($event)" maxlength="4" />
                              <span style="color: red; font-size: 16px;">*</span>
                           </div>
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="text-align:center"> Action </th>
                        <td mat-cell *matCellDef="let element">
                           <button class="btn btn-custom" matTooltip="Some of the informations are missing"
                              [matTooltipDisabled]="!(!agreementPassCheck || !selectedMembership.effectiveDate || selectedMembership.effectiveDate == '' || disablePayDepositBtn || !immunizationPassCheck)"
                              [disabled]="!agreementPassCheck || !selectedMembership.effectiveDate || selectedMembership.effectiveDate == '' || disablePayDepositBtn || !immunizationPassCheck"
                              (click)="makePaymentForMembership(true,element)" style="margin-right: 10px;"
                              *ngIf="activeCards && activeCards.length >0">
                              Purchase with this card
                           </button>
                        </td>
                     </ng-container>
                     <tr mat-header-row *matHeaderRowDef="cardColumns"></tr>
                     <tr mat-row *matRowDef="let row; columns: cardColumns;"></tr>
                  </table>
                  <re-captcha *ngIf="showCaptchaForCard" siteKey="6LdMENsZAAAAAMqFM9PKysYwkmEO778o2j_iS9Qh"
                     (resolved)="onCardCaptchaResolved($event)">
                  </re-captcha>
                  <p *ngIf="cardCaptchaError" style="color: red;">{{ cardCaptchaError }}</p>
                  <button class="btn btn-custom" matTooltip="Some of the informations are missing"
                     [matTooltipDisabled]="!(!agreementPassCheck || !selectedMembership.effectiveDate || selectedMembership.effectiveDate == '' || disablePayDepositBtn || !immunizationPassCheck)"
                     [disabled]="!agreementPassCheck || !selectedMembership.effectiveDate || selectedMembership.effectiveDate == '' || disablePayDepositBtn || !immunizationPassCheck"
                     (click)="makePaymentForMembership(false,null)" style="margin-right: 10px;">
                     Purchase
                  </button>
               </div>
               <div style="margin-top: 10px;">
                  <button class="btn btn-custom float-left" [disabled]="disablePayDepositBtn"
                     (click)="goBack('petDetail')">Back</button>
               </div>
            </ng-container>

            <ng-container *ngIf="selectedPackage && selectedPurchaseType == 'package'">
               <div style="text-align: center;" *ngIf="selectedPackage.allowAutoRenewal">
                  <mat-radio-group name="packagePurchaseType" [(ngModel)]="selectedPackage.autoRenewal"
                     [ngModelOptions]="{standalone: true}">
                     <mat-radio-button value="false">Purchase Once</mat-radio-button>
                     <mat-radio-button value="true">Setup Auto Renew</mat-radio-button>
                  </mat-radio-group>
               </div>
               <div *ngIf="selectedPackage.allowAutoRenewal" style="text-align: center;">
                  <h3 style="margin-bottom: 0px;">Setup Auto-Renew for {{selectedPackage.packageName}}</h3>
                  <p>In order to setup recurring payments for this purchase the client needs to have a saved card on
                     file</p>
               </div>
               <div *ngIf="selectedPackage.renewalType && selectedPackage.renewalType=='EXPIRATION_DATE'"
                  style="text-align: center;">
                  <mat-form-field appearance="outline">
                     <mat-label>Package Start Date</mat-label>
                     <input matInput [matDatepicker]="picker" placeholder="Package Start Date"
                        [(ngModel)]="selectedPackage.startDate" (ngModelChange)="packageStartDateChange($event)"
                        [min]="minDate" required>
                     <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                     <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
               </div>
            </ng-container>
            <ng-container *ngIf="selectedPackage && selectedPurchaseType == 'package'">
               <div style="margin: auto;margin-bottom: 10px !important;width: 55%;border:1px dashed;padding: 15px;">
                  <div>
                     <span>
                        <div
                           style="display: flex; justify-content: space-between;margin: 0px -15px;padding: 0px 15px;padding-bottom: 5px;border-bottom: 1px dashed grey;margin-bottom: 10px;">
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">
                                 Item Details
                              </p>
                           </div>
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">Amount</p>
                           </div>
                        </div>
                     </span>
                  </div>
                  <div style="display: flex; justify-content: space-between;">
                     <div style="display: flex; flex-direction: column;">
                        <p>
                           {{selectedPackage.packageName}}
                           <span (click)="showInvoiceDescription()">></span>
                        </p>
                        <span *ngIf="showRules">
                           <span *ngIf="selectedPackage.services && selectedPackage.services.length > 0">
                              <span *ngFor="let data of selectedPackage.serviceRules;index as i">
                                 <span *ngFor="let service of data.rule">
                                    {{service.name}} - {{service.quantity}}<br>
                                 </span>
                                 <span *ngIf="i != ( selectedPackage.serviceRules.length - 1)">
                                    <h5 style="margin:5px 0px !important">(OR)</h5>
                                 </span>
                              </span>
                           </span>
                        </span>
                     </div>
                     <div style="display: flex; flex-direction: column;">
                        <p style="font-weight: 600;margin-bottom: 0px;">${{selectedPackage.price.toFixed(2)}}</p>
                        <p style="margin: 0px;text-align: right;"
                           *ngIf="selectedPackage.tax && selectedPackage.tax > 0">Tax: {{selectedPackage.tax || 0 }} %
                        </p>
                     </div>
                  </div>
                  <hr *ngIf="hasvalidCoupon && couponDetails" class="sample-invoive-hr">
                  <div style="display: flex; justify-content: space-between;align-items: baseline;"
                     *ngIf="hasvalidCoupon && couponDetails">
                     <div style="display: flex; flex-direction: column;">
                        <p>
                           {{couponDetails.name}} - {{couponDetails.code}} ({{getCouponDiscountValue()}})
                        </p>
                     </div>
                     <div style="display: flex; flex-direction: column;">
                        <p style="margin-right:-15px;">- $ {{getCouponDiscount()}}<mat-icon
                              style="color: red;margin: 5px;cursor: pointer;vertical-align: middle;"
                              (click)="removeCoupon()">delete</mat-icon></p>
                     </div>
                  </div>
                  <hr *ngIf="!hasCoupon && !hasvalidCoupon" class="sample-invoive-hr">
                  <div style="text-align: right;" *ngIf="!hasCoupon && !hasvalidCoupon">
                     <button style="cursor: pointer;" class="btn btn-custom" (click)="addCoupon()">Add Coupon</button>
                  </div>
                  <div style="display: flex; justify-content: space-between;">
                     <div *ngIf="hasCoupon && !hasvalidCoupon">
                        <mat-form-field appearance="outline">
                           <mat-label>Coupon Code</mat-label>
                           <input matInput [(ngModel)]="couponCode" style="margin-top: 10px;"
                              placeholder="Enter Coupon Code">
                        </mat-form-field>
                        <mat-icon style="color:green;margin: 5px;cursor: pointer;"
                           (click)="validateCoupon()">check</mat-icon>
                        <mat-icon style="color: red;margin: 5px;cursor: pointer;"
                           (click)="removeCoupon()">close</mat-icon>
                     </div>
                  </div>
                  <hr class="sample-invoive-hr">
                  <div>
                     <span>
                        <div
                           style="display: flex; justify-content: space-between;margin: 0px -15px;padding: 0px 15px;padding-top: 5px;border-top: 1px dashed grey;margin-top: 10px;">
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">
                                 Total:
                              </p>
                           </div>
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">${{getPaymentTotal()}}</p>
                           </div>
                        </div>
                     </span>
                  </div>
               </div>
            </ng-container>
            <ng-container *ngIf="selectedPackage  && selectedPurchaseType == 'package'">
               <div style="background-color: #eee;text-align: center;border-radius: 5px;padding: 1rem;">
                  <p style="font-size: 1.5rem;line-height: 3;" *ngIf="selectedPackage">{{ 'Payment of $' +
                     getPaymentTotal() +' Required'}}</p>
                  <table mat-table [dataSource]="activeCards" class="mat-elevation-z8"
                     style="width:100%; margin-bottom: 10px; margin-top: 10px;"
                     *ngIf="activeCards && activeCards.length > 0">
                     <ng-container matColumnDef="details">
                        <th mat-header-cell *matHeaderCellDef> Save card on file </th>
                        <td mat-cell *matCellDef="let element">
                           <div class="cod_inner">
                              <!-- <mat-radio-button [value]="element" (change)="handleCardChange($event)"
                                    style="margin-left: 0px !important;">
                                 </mat-radio-button> -->
                              <div style="display: flex; align-items: center; font-weight: 550;">
                                 <mat-icon style="margin-right: 10px;">credit_card</mat-icon>
                                 **** **** **** {{ element.lastFourDigit.substring(element.lastFourDigit.length - 4) }}
                              </div>
                           </div>
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="cvvDetails">
                        <th mat-header-cell *matHeaderCellDef> CVV </th>
                        <td mat-cell *matCellDef="let element">
                           <div style="display: flex; width: fit-content;">
                              <input *ngIf="element.ccvRequired" type="text" class="form-control" placeholder="CVV"
                                 [(ngModel)]="element.cvvValue" style="width: 100px; margin: auto;"
                                 (keypress)="validateNumberInput($event)" maxlength="4" />
                              <span style="color: red; font-size: 16px;">*</span>
                           </div>
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="text-align:center"> Action </th>
                        <td mat-cell *matCellDef="let element">
                           <button class="btn btn-custom" (click)="makePaymentForPackage(true,element)"
                              matTooltip="Some of the informations are missing"
                              [matTooltipDisabled]="!(!selectedPackage.effectiveDate || selectedPackage.effectiveDate == '' || disablePayDepositBtn)"
                              [disabled]="!selectedPackage.effectiveDate || selectedPackage.effectiveDate == '' || disablePayDepositBtn"
                              style="margin-right: 10px;" *ngIf="activeCards && activeCards.length >0">
                              Purchase with this card
                           </button>
                        </td>
                     </ng-container>
                     <tr mat-header-row *matHeaderRowDef="cardColumns"></tr>
                     <tr mat-row *matRowDef="let row; columns: cardColumns;"></tr>
                  </table>
                  <re-captcha *ngIf="showCaptchaForCard" siteKey="6LdMENsZAAAAAMqFM9PKysYwkmEO778o2j_iS9Qh"
                     (resolved)="onCardCaptchaResolved($event)">
                  </re-captcha>
                  <p *ngIf="cardCaptchaError" style="color: red;">{{ cardCaptchaError }}</p>
                  <button class="btn btn-custom" (click)="makePaymentForPackage(false,null)"
                     matTooltip="Some of the informations are missing"
                     [matTooltipDisabled]="!(!selectedPackage.effectiveDate || selectedPackage.effectiveDate == '' || disablePayDepositBtn)"
                     [disabled]="!selectedPackage.effectiveDate || selectedPackage.effectiveDate == '' || disablePayDepositBtn"
                     style="margin-right: 10px;">
                     Purchase Using New Card
                  </button>
               </div>
               <div style="margin-top: 10px;">
                  <button class="btn btn-custom float-left" [disabled]="disablePayDepositBtn"
                     (click)="goBack('login')">Back</button>
               </div>
            </ng-container>

            <ng-container *ngIf="selectedSession && selectedPurchaseType == 'training'">
               <div
                  *ngIf="selectedSession.groupService && selectedSession.groupService.enrollmentType == 'FIXED_CLASS_SCHEDULE'">
                  <div class="training-card">
                     <div style="text-align: center;">
                        <h2>{{selectedSession.groupService.name}}</h2>
                        <p style="font-weight: 600;font-size:16px"
                           *ngIf="selectedSession.groupService.trainingType != 'PRIVATE'">{{selectedSession.name}}</p>
                        <p>Starts at {{getDateAndTime(selectedSession.recurringStartDate,'dateTime')}}</p>
                        <p *ngIf="selectedSession.durationInText && selectedSession.durationInText != ''">Duration :
                           {{selectedSession.durationInText}}</p>
                        <p>Classes : {{selectedSession.noOfAppointments}} {{selectedSession.noOfAppointments > 1 ?
                           'classes' : 'class'}} </p>
                        <span *ngIf="selectedSession.groupService.trainingType != 'PRIVATE'">
                           <span *ngFor="let class of selectedSession.classes">
                              {{class.name}} - {{getDateAndTime(class.appointmentDate,'dateTime')}}<br>
                           </span>
                        </span>
                     </div>
                  </div>
               </div>
               <div
                  *ngIf="selectedSession.groupService && selectedSession.groupService.enrollmentType != 'FIXED_CLASS_SCHEDULE'">
                  <div class="training-card">
                     <div style="text-align: center;">
                        <h2>{{selectedSession.groupService.name}}</h2>
                        <p style="font-weight: 600;font-size:16px">{{selectedSession.name}}</p>
                        <p *ngIf="selectedSession.durationInText && selectedSession.durationInText != ''">Duration :
                           {{selectedSession.durationInText}}</p>
                        <span *ngIf="selectedSession.groupService.autoApproval">
                           <table mat-table [dataSource]="selectedSession.groupedClasses" style="width:100%">
                              <ng-container matColumnDef="name">
                                 <th mat-header-cell *matHeaderCellDef> Name </th>
                                 <td mat-cell *matCellDef="let element" style="text-align: left;"> {{element.name}}
                                 </td>
                              </ng-container>
                              <ng-container matColumnDef="select">
                                 <th mat-header-cell *matHeaderCellDef style="width:20%;text-align: center;"> Select
                                 </th>
                                 <td mat-cell *matCellDef="let element">
                                    <mat-form-field appearance="outline" class='class-autoAssign'>
                                       <mat-label>Class</mat-label>
                                       <mat-select [(value)]="element.assignedClass">
                                          <mat-option *ngFor="let class of element.classDetails" [value]="class">
                                             {{class.displayName}}
                                          </mat-option>
                                       </mat-select>
                                    </mat-form-field>
                                 </td>
                              </ng-container>
                              <tr mat-header-row *matHeaderRowDef="openEnrollmentClasses"></tr>
                              <tr mat-row *matRowDef="let row; columns: openEnrollmentClasses;"></tr>
                           </table>
                        </span>
                        <span *ngIf="!selectedSession.groupService.autoApproval">
                           <span *ngFor="let class of selectedSession.groupedClasses">
                              {{class.name}} <br>
                           </span>
                        </span>
                     </div>
                  </div>
               </div>
            </ng-container>
            <ng-container *ngIf="selectedSession && selectedPurchaseType == 'training'">
               <div style="margin: auto;margin-bottom: 10px !important;width: 55%;border:1px dashed;padding: 15px;">
                  <div>
                     <span>
                        <div
                           style="display: flex; justify-content: space-between;margin: 0px -15px;padding: 0px 15px;padding-bottom: 5px;border-bottom: 1px dashed grey;margin-bottom: 10px;">
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">
                                 Item Details
                              </p>
                           </div>
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">Amount</p>
                           </div>
                        </div>
                     </span>
                  </div>
                  <div *ngFor="let pet of userPets">
                     <span *ngIf="pet.selected">
                        <div style="display: flex; justify-content: space-between;">
                           <div style="display: flex; flex-direction: column;">
                              <p>
                                 {{selectedSession.name}} - {{pet.name}}
                              </p>
                           </div>
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">
                                 ${{selectedSession.groupService.priceTiers[0].amount.toFixed(2)}}</p>
                              <p style="margin: 0px;text-align: right;"
                                 *ngIf="selectedSession.groupService.taxPercentage && selectedSession.groupService.taxPercentage > 0">
                                 Tax: {{selectedSession.groupService.taxPercentage || 0 }} %</p>
                           </div>
                        </div>
                        <hr class="sample-invoive-hr">
                     </span>
                  </div>
                  <div style="display: flex; justify-content: space-between;align-items: baseline;"
                     *ngIf="hasvalidCoupon && couponDetails">
                     <div style="display: flex; flex-direction: column;">
                        <p>
                           {{couponDetails.name}} - {{couponDetails.code}} ({{getCouponDiscountValue()}})
                        </p>
                     </div>
                     <div style="display: flex; flex-direction: column;">
                        <p style="margin-right:-15px;">- $ {{getCouponDiscount()}}<mat-icon
                              style="color: red;margin: 5px;cursor: pointer;vertical-align: middle;"
                              (click)="removeCoupon()">delete</mat-icon></p>
                     </div>
                  </div>
                  <div style="text-align: right;" *ngIf="!hasCoupon && !hasvalidCoupon">
                     <button style="cursor: pointer;" class="btn btn-custom" (click)="addCoupon()">Add Coupon</button>
                  </div>
                  <div style="display: flex; justify-content: space-between;">
                     <div *ngIf="hasCoupon && !hasvalidCoupon">
                        <mat-form-field appearance="outline">
                           <mat-label>Coupon Code</mat-label>
                           <input matInput [(ngModel)]="couponCode" style="margin-top: 10px;"
                              placeholder="Enter Coupon Code">
                        </mat-form-field>
                        <mat-icon style="color:green;margin: 5px;cursor: pointer;"
                           (click)="validateCoupon()">check</mat-icon>
                        <mat-icon style="color: red;margin: 5px;cursor: pointer;"
                           (click)="removeCoupon()">close</mat-icon>
                     </div>
                  </div>
                  <div>
                     <span>
                        <div
                           style="display: flex; justify-content: space-between;margin: 0px -15px;padding: 0px 15px;padding-top: 5px;border-top: 1px dashed grey;margin-top: 10px;">
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">
                                 Total:
                              </p>
                           </div>
                           <div style="display: flex; flex-direction: column;">
                              <p style="font-weight: 600;margin-bottom: 0px;">${{getPaymentTotal()}}</p>
                           </div>
                        </div>
                     </span>
                  </div>
               </div>
            </ng-container>
            <ng-container *ngIf="selectedSession  && selectedPurchaseType == 'training'">
               <div style="background-color: #eee;text-align: center;border-radius: 5px;padding: 1rem;">
                  <p style="font-size: 1.5rem;line-height: 3;" *ngIf="selectedSession">{{ 'Payment of $' +
                     getPaymentTotal() +' Required'}}</p>
                  <table mat-table [dataSource]="activeCards" class="mat-elevation-z8"
                     style="width:100%; margin-bottom: 10px; margin-top: 10px;"
                     *ngIf="activeCards && activeCards.length > 0">
                     <ng-container matColumnDef="details">
                        <th mat-header-cell *matHeaderCellDef> Save card on file </th>
                        <td mat-cell *matCellDef="let element">
                           <div class="cod_inner">
                              <!-- <mat-radio-button [value]="element" (change)="handleCardChange($event)"
                                    style="margin-left: 0px !important;">
                                 </mat-radio-button> -->
                              <div style="display: flex; align-items: center; font-weight: 550;">
                                 <mat-icon style="margin-right: 10px;">credit_card</mat-icon>
                                 **** **** **** {{ element.lastFourDigit.substring(element.lastFourDigit.length - 4) }}
                              </div>
                           </div>
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="cvvDetails">
                        <th mat-header-cell *matHeaderCellDef> CVV </th>
                        <td mat-cell *matCellDef="let element">
                           <div style="display: flex; width: fit-content;">
                              <input *ngIf="element.ccvRequired" type="text" class="form-control" placeholder="CVV"
                                 [(ngModel)]="element.cvvValue" style="width: 100px; margin: auto;"
                                 (keypress)="validateNumberInput($event)" maxlength="4" />
                              <span style="color: red; font-size: 16px;">*</span>
                           </div>
                        </td>
                     </ng-container>
                     <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="text-align:center"> Action </th>
                        <td mat-cell *matCellDef="let element">
                           <button class="btn btn-custom" (click)="makePaymentForTraining(true,element)"
                              matTooltip="Some of the informations are missing"
                              [matTooltipDisabled]="!(!agreementPassCheck || !immunizationPassCheck || disablePayDepositBtn || isDisablePayBtnForTraining())"
                              [disabled]="!agreementPassCheck || !immunizationPassCheck || disablePayDepositBtn || isDisablePayBtnForTraining()"
                              style="margin-right: 10px;" *ngIf="activeCards && activeCards.length >0">
                              Purchase with this card
                           </button>
                        </td>
                     </ng-container>
                     <tr mat-header-row *matHeaderRowDef="cardColumns"></tr>
                     <tr mat-row *matRowDef="let row; columns: cardColumns;"></tr>
                  </table>
                  <re-captcha *ngIf="showCaptchaForCard" siteKey="6LdMENsZAAAAAMqFM9PKysYwkmEO778o2j_iS9Qh"
                     (resolved)="onCardCaptchaResolved($event)">
                  </re-captcha>
                  <p *ngIf="cardCaptchaError" style="color: red;">{{ cardCaptchaError }}</p>
                  <button class="btn btn-custom" (click)="makePaymentForTraining(false,null)"
                     matTooltip="Some of the informations are missing"
                     [matTooltipDisabled]="!(!agreementPassCheck || !immunizationPassCheck || disablePayDepositBtn || isDisablePayBtnForTraining())"
                     [disabled]="!agreementPassCheck || !immunizationPassCheck || disablePayDepositBtn || isDisablePayBtnForTraining()"
                     style="margin-right: 10px;">
                     Purchase Using New Card
                  </button>
               </div>
               <div style="margin-top: 10px;">
                  <button class="btn btn-custom float-left" [disabled]="disablePayDepositBtn"
                     (click)="goBack('petDetail')">Back</button>
               </div>
            </ng-container>
         </mat-step>
      </mat-horizontal-stepper>
      <mat-progress-bar mode="indeterminate" *ngIf="buffer"></mat-progress-bar>
   </div>
   <div class="card-footer text-muted text-center">
      <a href="https://www.runloyal.com/" target="_blank" class="text-dark">
         <div class="footer-img" alt="">
            <img src="assets\images\Made-with-love.png" width="200px" style="object-fit: scale-down;">
         </div>
      </a>
   </div>
</div>
<p style="margin: 0; float: right;">1.117</p>
<div *ngIf="isPageLoader" class="page-content-loader">
   <div class="content-loader">Loading...</div>
</div>